// @generated — do not edit manually. Run `npm run generate` to regenerate.

import type { ThemeColors, ThemePresetColors, ThemePresetId, ThemePreset, ThemeShadows, SurfaceScopes, ThemeSpacing, ThemeBorderRadius } from './types.js';

// ---------------------------------------------------------------------------
// Base token sets
// ---------------------------------------------------------------------------

export const BASE_LIGHT: ThemeColors = {
  surface0: '0.957 0.0029 84.6',
  surface0Hover: '0.934 0.0044 84.6',
  surface0Active: '0.911 0.0059 84.6',
  surface0Highlight: '0.942 0.0059 84.6',
  surface1: '0.957 0.0029 84.6',
  surface1Hover: '0.934 0.0044 84.6',
  surface1Active: '0.911 0.0059 84.6',
  surface1Highlight: '0.942 0.0059 84.6',
  surface2: '1 0 0',
  surface2Hover: '0.977 0 0',
  surface2Active: '0.954 0 0',
  surface2Highlight: '0.971 0.0019 84.6',
  surface3: '1 0 0',
  surface3Hover: '0.977 0 0',
  surface3Active: '0.954 0 0',
  surface3Highlight: '0.971 0.0019 84.6',
  surface4: '0.985 0.003 84.6',
  surface4Hover: '0.965 0.004 84.6',
  surface4Active: '0.945 0.005 84.6',
  surface4Highlight: '0.96 0.006 84.6',
  fg: '0.145 0 0',
  fgSecondary: '0.48 0 0',
  fgTertiary: '0.55 0 0',
  fgDisabled: '0.68 0 0',
  fgInverse: '0.985 0 0',
  fgLink: '0.204 0 0',
  fgSuccess: '0.55 0.16 149.7',
  fgWarning: '0.55 0.16 75',
  fgError: '0.636 0.2082 25.4',
  borderSubtle: '0.9 0 0',
  borderDefault: '0.845 0 0',
  borderMainContent: '0.875 0 0',
  borderSuccess: '0.7 0.12 155',
  borderWarning: '0.75 0.12 85',
  borderError: '0.65 0.15 25',
  accent: '0.97 0 0',
  accentForeground: '0.204 0 0',
  accentHover: '0.923 0 0',
  accentActive: '0.921 0.003 0',
  accentSubtle: '0.965 0.005 90',
  accentMuted: '0.975 0.003 90',
  accentBorder: '0.85 0.01 90',
  ctaBg: '0.145 0 0',
  ctaFg: '0.985 0 0',
  ctaBgHover: '0.25 0 0',
  ctaBgActive: '0.32 0 0',
  ctaBorder: '0.145 0 0',
  sidebarAccent: '0.97 0 0',
  sidebarAccentForeground: '0.204 0 0',
  sidebarHover: '0.962 0 0',
  tabBg: '0.918 0.0043 84.6',
  tabBgHover: '0.896 0.0056 84.6',
  tabOutline: '0.829 0 0',
  inputBg: '1 0 0',
  inputBorder: '0.9 0 0',
  inputBorderHover: '0.845 0 0',
  inputBorderFocus: '0.65 0 0',
  inputBorderError: '0.636 0.2082 25.4',
  inputBorderActive: '0.805 0 0',
  inputBorderHighlight: '0.851 0.01 84.6',
  inputBgActive: '0.977 0 0',
  inputBgHighlight: '0.978 0.0022 84.6',
  inputBgDisabled: '0.97 0 0',
  inputPlaceholder: '0.649 0 0',
  bgSuccess: '0.945 0.06 155',
  bgWarning: '0.95 0.06 85',
  bgError: '0.935 0.04 25',
  contentPreviewBg: '0.9 0.0029 84.6',
  contentPreviewFg: '0.45 0 0',
  contentPreviewBorder: '0.85 0.0029 84.6',
};

export const BASE_DARK: ThemeColors = {
  surface0: '0.262 0 0',
  surface0Hover: '0.278 0 0',
  surface0Active: '0.301 0 0',
  surface0Highlight: '0.285 0 0',
  surface1: '0.264 0 0',
  surface1Hover: '0.301 0 0',
  surface1Active: '0.331 0 0',
  surface1Highlight: '0.311 0 0',
  surface2: '0.301 0 0',
  surface2Hover: '0.341 0 0',
  surface2Active: '0.371 0 0',
  surface2Highlight: '0.351 0 0',
  surface3: '0.285 0 0',
  surface3Hover: '0.321 0 0',
  surface3Active: '0.351 0 0',
  surface3Highlight: '0.331 0 0',
  surface4: '0.321 0 0',
  surface4Hover: '0.361 0 0',
  surface4Active: '0.39 0 0',
  surface4Highlight: '0.371 0 0',
  fg: '0.923 0 0',
  fgSecondary: '0.715 0 0',
  fgTertiary: '0.6 0 0',
  fgDisabled: '0.48 0 0',
  fgInverse: '0.204 0 0',
  fgLink: '0.985 0 0',
  fgSuccess: '0.72 0.192 149.5',
  fgWarning: '0.77 0.1645 70.6',
  fgError: '0.62 0.19 25.4',
  borderSubtle: '0.321 0 0',
  borderDefault: '0.371 0 0',
  borderMainContent: '0.29 0 0',
  borderSuccess: '0.5 0.1 155',
  borderWarning: '0.55 0.1 85',
  borderError: '0.45 0.12 25',
  accent: '0.216 0 0',
  accentForeground: '0.923 0 0',
  accentHover: '0.27 0 0',
  accentActive: '0.2 0.003 0',
  accentSubtle: '0.18 0.005 90',
  accentMuted: '0.15 0.003 90',
  accentBorder: '0.35 0.01 90',
  ctaBg: '0.985 0 0',
  ctaFg: '0.145 0 0',
  ctaBgHover: '0.9 0 0',
  ctaBgActive: '0.82 0 0',
  ctaBorder: '0.985 0 0',
  sidebarAccent: '0.216 0 0',
  sidebarAccentForeground: '0.923 0 0',
  sidebarHover: '0.204 0 0',
  tabBg: '0.301 0 0',
  tabBgHover: '0.341 0 0',
  tabOutline: '0.418 0 0',
  inputBg: '0.27 0 0',
  inputBorder: '0.341 0 0',
  inputBorderHover: '0.399 0 0',
  inputBorderFocus: '0.454 0 0',
  inputBorderError: '0.562 0.1966 26.3',
  inputBorderActive: '0.437 0 0',
  inputBorderHighlight: '0.418 0 0',
  inputBgActive: '0.301 0 0',
  inputBgHighlight: '0.29 0 0',
  inputBgDisabled: '0.248 0 0',
  inputPlaceholder: '0.581 0 0',
  bgSuccess: '0.22 0.04 155',
  bgWarning: '0.23 0.04 85',
  bgError: '0.22 0.035 25',
  contentPreviewBg: '0.32 0 0',
  contentPreviewFg: '0.715 0 0',
  contentPreviewBorder: '0.371 0 0',
};

export const BASE_LIGHT_EXTENDED: Partial<ThemePresetColors> = {
  background: '0.957 0.0029 84.6',
  panelBackground: '0.957 0.0029 84.6',
  mainPanelBackground: '0.957 0.0029 84.6',
  ring: '0.145 0 0',
  overlay: '0 0 0 / 0.5',
  surfaceGlass: '0.985 0.003 90 / 0.75',
  skeleton: '0.92 0 0 / 1',
};

export const BASE_DARK_EXTENDED: Partial<ThemePresetColors> = {
  background: '0.262 0 0',
  panelBackground: '0.264 0 0',
  mainPanelBackground: '0.264 0 0',
  ring: '0.923 0 0',
  overlay: '0 0 0 / 0.6',
  surfaceGlass: '0.2 0.003 90 / 0.75',
  skeleton: '0.27 0 0 / 1',
};

// ---------------------------------------------------------------------------
// Surface-contextual scopes
// ---------------------------------------------------------------------------

export const SURFACE_SCOPES_LIGHT: SurfaceScopes = {
  '0': {
    fg: '0.145 0 0',
    fgSecondary: '0.48 0 0',
    fgTertiary: '0.55 0 0',
    fgDisabled: '0.68 0 0',
    inputBg: '1 0 0',
    inputBorder: '0.885 0 0',
    inputBorderHover: '0.829 0 0',
    inputBorderFocus: '0.829 0 0',
    inputBorderError: '0.636 0.2082 25.4',
    inputBorderActive: '0.789 0 0',
    inputBorderHighlight: '0.836 0.0111 84.6',
    inputBgActive: '0.977 0 0',
    inputBgHighlight: '0.978 0.0022 84.6',
    inputBgDisabled: '0.962 0 0',
    inputPlaceholder: '0.649 0 0',
    tabBg: '0.918 0.0043 84.6',
    tabBgHover: '0.896 0.0056 84.6',
    tabOutline: '0.829 0 0',
    borderSubtle: '0.9 0 0',
    borderDefault: '0.845 0 0',
    ctaBg: '0.145 0 0',
    ctaFg: '0.985 0 0',
    ctaBgHover: '0.25 0 0',
    ctaBgActive: '0.32 0 0',
    ctaBorder: '0.145 0 0',
  },
  '1': {
    fg: '0.145 0 0',
    fgSecondary: '0.48 0 0',
    fgTertiary: '0.55 0 0',
    fgDisabled: '0.68 0 0',
    inputBg: '1 0 0',
    inputBorder: '0.885 0 0',
    inputBorderHover: '0.829 0 0',
    inputBorderFocus: '0.829 0 0',
    inputBorderError: '0.636 0.2082 25.4',
    inputBorderActive: '0.789 0 0',
    inputBorderHighlight: '0.836 0.0111 84.6',
    inputBgActive: '0.977 0 0',
    inputBgHighlight: '0.978 0.0022 84.6',
    inputBgDisabled: '0.962 0 0',
    inputPlaceholder: '0.649 0 0',
    tabBg: '0.918 0.0043 84.6',
    tabBgHover: '0.896 0.0056 84.6',
    tabOutline: '0.829 0 0',
    borderSubtle: '0.9 0 0',
    borderDefault: '0.845 0 0',
    ctaBg: '0.18 0 0',
    ctaFg: '0.985 0 0',
    ctaBgHover: '0.28 0 0',
    ctaBgActive: '0.35 0 0',
    ctaBorder: '0.18 0 0',
  },
  '2': {
    fg: '0.145 0 0',
    fgSecondary: '0.48 0 0',
    fgTertiary: '0.55 0 0',
    fgDisabled: '0.68 0 0',
    inputBg: '0.992 0 0',
    inputBorder: '0.877 0 0',
    inputBorderHover: '0.821 0 0',
    inputBorderFocus: '0.821 0 0',
    inputBorderError: '0.636 0.2082 25.4',
    inputBorderActive: '0.781 0 0',
    inputBorderHighlight: '0.828 0.0116 84.6',
    inputBgActive: '0.97 0 0',
    inputBgHighlight: '0.971 0.0029 84.6',
    inputBgDisabled: '0.954 0 0',
    inputPlaceholder: '0.649 0 0',
    tabBg: '0.9 0 0',
    tabBgHover: '0.877 0 0',
    tabOutline: '0.829 0 0',
    borderSubtle: '0.892 0 0',
    borderDefault: '0.837 0 0',
    ctaBg: '0.22 0 0',
    ctaFg: '0.985 0 0',
    ctaBgHover: '0.32 0 0',
    ctaBgActive: '0.39 0 0',
    ctaBorder: '0.22 0 0',
  },
  '3': {
    fg: '0.145 0 0',
    fgSecondary: '0.48 0 0',
    fgTertiary: '0.55 0 0',
    fgDisabled: '0.68 0 0',
    inputBg: '0.97 0 0',
    inputBorder: '0.861 0 0',
    inputBorderHover: '0.805 0 0',
    inputBorderFocus: '0.805 0 0',
    inputBorderError: '0.636 0.2082 25.4',
    inputBorderActive: '0.765 0 0',
    inputBorderHighlight: '0.813 0.0127 84.6',
    inputBgActive: '0.947 0 0',
    inputBgHighlight: '0.957 0.0044 84.6',
    inputBgDisabled: '0.947 0 0',
    inputPlaceholder: '0.649 0 0',
    tabBg: '0.954 0 0',
    tabBgHover: '0.931 0 0',
    tabOutline: '0.829 0 0',
    borderSubtle: '0.885 0 0',
    borderDefault: '0.829 0 0',
    ctaBg: '0.26 0 0',
    ctaFg: '0.985 0 0',
    ctaBgHover: '0.36 0 0',
    ctaBgActive: '0.43 0 0',
    ctaBorder: '0.26 0 0',
  },
  '4': {
    fg: '0.145 0 0',
    fgSecondary: '0.48 0 0',
    fgTertiary: '0.55 0 0',
    fgDisabled: '0.68 0 0',
    inputBg: '0.97 0 0',
    inputBorder: '0.861 0 0',
    inputBorderHover: '0.805 0 0',
    inputBorderFocus: '0.805 0 0',
    inputBorderError: '0.636 0.2082 25.4',
    inputBorderActive: '0.765 0 0',
    inputBorderHighlight: '0.813 0.0127 84.6',
    inputBgActive: '0.947 0 0',
    inputBgHighlight: '0.957 0.0044 84.6',
    inputBgDisabled: '0.947 0 0',
    inputPlaceholder: '0.649 0 0',
    tabBg: '0.954 0 0',
    tabBgHover: '0.931 0 0',
    tabOutline: '0.829 0 0',
    borderSubtle: '0.885 0 0',
    borderDefault: '0.829 0 0',
    ctaBg: '0.3 0 0',
    ctaFg: '0.985 0 0',
    ctaBgHover: '0.4 0 0',
    ctaBgActive: '0.47 0 0',
    ctaBorder: '0.3 0 0',
  },
};

export const SURFACE_SCOPES_DARK: SurfaceScopes = {
  '0': {
    fg: '0.923 0 0',
    fgSecondary: '0.715 0 0',
    fgTertiary: '0.6 0 0',
    fgDisabled: '0.48 0 0',
    inputBg: '0.28 0 0',
    inputBorder: '0.341 0 0',
    inputBorderHover: '0.399 0 0',
    inputBorderFocus: '0.454 0 0',
    inputBorderError: '0.562 0.1966 26.3',
    inputBorderActive: '0.437 0 0',
    inputBorderHighlight: '0.418 0 0',
    inputBgActive: '0.311 0 0',
    inputBgHighlight: '0.301 0 0',
    inputBgDisabled: '0.216 0 0',
    inputPlaceholder: '0.581 0 0',
    tabBg: '0.301 0 0',
    tabBgHover: '0.341 0 0',
    tabOutline: '0.399 0 0',
    borderSubtle: '0.321 0 0',
    borderDefault: '0.371 0 0',
    ctaBg: '0.985 0 0',
    ctaFg: '0.145 0 0',
    ctaBgHover: '0.9 0 0',
    ctaBgActive: '0.82 0 0',
    ctaBorder: '0.985 0 0',
  },
  '1': {
    fg: '0.923 0 0',
    fgSecondary: '0.715 0 0',
    fgTertiary: '0.6 0 0',
    fgDisabled: '0.48 0 0',
    inputBg: '0.301 0 0',
    inputBorder: '0.361 0 0',
    inputBorderHover: '0.418 0 0',
    inputBorderFocus: '0.473 0 0',
    inputBorderError: '0.562 0.1966 26.3',
    inputBorderActive: '0.456 0 0',
    inputBorderHighlight: '0.437 0 0',
    inputBgActive: '0.331 0 0',
    inputBgHighlight: '0.321 0 0',
    inputBgDisabled: '0.238 0 0',
    inputPlaceholder: '0.581 0 0',
    tabBg: '0.321 0 0',
    tabBgHover: '0.361 0 0',
    tabOutline: '0.409 0 0',
    borderSubtle: '0.341 0 0',
    borderDefault: '0.39 0 0',
    ctaBg: '0.95 0 0',
    ctaFg: '0.145 0 0',
    ctaBgHover: '0.87 0 0',
    ctaBgActive: '0.79 0 0',
    ctaBorder: '0.95 0 0',
  },
  '2': {
    fg: '0.923 0 0',
    fgSecondary: '0.715 0 0',
    fgTertiary: '0.6 0 0',
    fgDisabled: '0.48 0 0',
    inputBg: '0.341 0 0',
    inputBorder: '0.399 0 0',
    inputBorderHover: '0.456 0 0',
    inputBorderFocus: '0.511 0 0',
    inputBorderError: '0.562 0.1966 26.3',
    inputBorderActive: '0.492 0 0',
    inputBorderHighlight: '0.474 0 0',
    inputBgActive: '0.371 0 0',
    inputBgHighlight: '0.361 0 0',
    inputBgDisabled: '0.28 0 0',
    inputPlaceholder: '0.581 0 0',
    tabBg: '0.361 0 0',
    tabBgHover: '0.399 0 0',
    tabOutline: '0.418 0 0',
    borderSubtle: '0.38 0 0',
    borderDefault: '0.418 0 0',
    ctaBg: '0.91 0 0',
    ctaFg: '0.145 0 0',
    ctaBgHover: '0.83 0 0',
    ctaBgActive: '0.75 0 0',
    ctaBorder: '0.91 0 0',
  },
  '3': {
    fg: '0.923 0 0',
    fgSecondary: '0.715 0 0',
    fgTertiary: '0.6 0 0',
    fgDisabled: '0.48 0 0',
    inputBg: '0.321 0 0',
    inputBorder: '0.38 0 0',
    inputBorderHover: '0.437 0 0',
    inputBorderFocus: '0.492 0 0',
    inputBorderError: '0.562 0.1966 26.3',
    inputBorderActive: '0.474 0 0',
    inputBorderHighlight: '0.456 0 0',
    inputBgActive: '0.351 0 0',
    inputBgHighlight: '0.341 0 0',
    inputBgDisabled: '0.259 0 0',
    inputPlaceholder: '0.581 0 0',
    tabBg: '0.341 0 0',
    tabBgHover: '0.38 0 0',
    tabOutline: '0.399 0 0',
    borderSubtle: '0.361 0 0',
    borderDefault: '0.399 0 0',
    ctaBg: '0.87 0 0',
    ctaFg: '0.145 0 0',
    ctaBgHover: '0.79 0 0',
    ctaBgActive: '0.71 0 0',
    ctaBorder: '0.87 0 0',
  },
  '4': {
    fg: '0.923 0 0',
    fgSecondary: '0.715 0 0',
    fgTertiary: '0.6 0 0',
    fgDisabled: '0.48 0 0',
    inputBg: '0.361 0 0',
    inputBorder: '0.418 0 0',
    inputBorderHover: '0.474 0 0',
    inputBorderFocus: '0.529 0 0',
    inputBorderError: '0.562 0.1966 26.3',
    inputBorderActive: '0.51 0 0',
    inputBorderHighlight: '0.492 0 0',
    inputBgActive: '0.39 0 0',
    inputBgHighlight: '0.38 0 0',
    inputBgDisabled: '0.301 0 0',
    inputPlaceholder: '0.581 0 0',
    tabBg: '0.38 0 0',
    tabBgHover: '0.418 0 0',
    tabOutline: '0.437 0 0',
    borderSubtle: '0.399 0 0',
    borderDefault: '0.437 0 0',
    ctaBg: '0.83 0 0',
    ctaFg: '0.145 0 0',
    ctaBgHover: '0.75 0 0',
    ctaBgActive: '0.67 0 0',
    ctaBorder: '0.83 0 0',
  },
};

// ---------------------------------------------------------------------------
// Per-preset overrides (only tokens that differ from the base)
// ---------------------------------------------------------------------------

type PartialColors = Partial<ThemeColors> & {
  background?: string;
  panelBackground?: string;
  mainPanelBackground?: string;
  ring?: string;
  overlay?: string;
  surfaceGlass?: string;
  skeleton?: string;
};

export const PRESET_OVERRIDES: Record<ThemePresetId, {
  light?: PartialColors;
  dark?: PartialColors;
  surfaceScopesLight?: SurfaceScopes;
  surfaceScopesDark?: SurfaceScopes;
}> = {
  default: {},

  ocean: {
    light: {
      surface0: '0.22 0.045 248',
      surface0Hover: '0.26 0.05 248',
      surface0Active: '0.3 0.055 248',
      surface0Highlight: '0.28 0.052 248',
      surface1: '1 0 0',
      surface1Hover: '0.967 0.0087 247.9',
      surface1Active: '0.942 0.0154 248',
      surface1Highlight: '0.959 0.0109 247.9',
      surface2: '0.93 0.004 247.9',
      surface2Hover: '0.946 0.0031 247.9',
      surface2Active: '0.914 0.0049 247.9',
      surface2Highlight: '0.93 0.006 247.9',
      surface3: '1 0 0',
      surface3Hover: '0.977 0.0013 247.8',
      surface3Active: '0.954 0.0026 247.9',
      surface3Highlight: '0.969 0.0026 247.8',
      surface4: '0.985 0.003 248',
      surface4Hover: '0.965 0.004 248',
      surface4Active: '0.945 0.005 248',
      surface4Highlight: '0.96 0.006 248',
      accent: '0.947 0.0263 248.1',
      accentForeground: '0.375 0.1222 254.7',
      accentHover: '0.896 0.0533 248.4',
      sidebarAccent: '0.55 0.13 255',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.28 0.055 248',
      borderSubtle: '0.899 0.0058 247.9',
      borderDefault: '0.843 0.009 247.9',
      borderMainContent: '0.892 0.0074 247.9',
      inputBg: '1 0 0',
      inputBorder: '0.899 0.0058 247.9',
      inputBorderHover: '0.842 0.0109 248',
      inputBorderFocus: '0.614 0.2114 256.2',
      inputBorderActive: '0.802 0.0137 248',
      inputBorderHighlight: '0.842 0.0136 248',
      inputBgActive: '0.977 0.001 247.8',
      inputBgHighlight: '0.977 0.002 247.8',
      inputBgDisabled: '0.969 0.0014 247.8',
      inputPlaceholder: '0.647 0.0106 248',
      tabBg: '0.914 0.0049 247.9',
      tabBgHover: '0.891 0.0062 247.9',
      tabOutline: '0.827 0.008 247.9',
      background: '0.22 0.045 248',
      panelBackground: '1 0 0',
      mainPanelBackground: '1 0 0',
      ring: '0.614 0.2114 255',
      contentPreviewBg: '0.93 0.012 247.9',
      contentPreviewFg: '0.45 0.04 248',
      contentPreviewBorder: '0.86 0.018 247.9',
    },
    dark: {
      surface0: '0.154 0.0212 246.5',
      surface0Hover: '0.189 0.0307 249.6',
      surface0Active: '0.222 0.0402 250.1',
      surface0Highlight: '0.2 0.0339 249.8',
      surface1: '0.189 0.0258 249.3',
      surface1Hover: '0.221 0.0339 249.6',
      surface1Active: '0.253 0.0415 249.8',
      surface1Highlight: '0.232 0.0365 249.7',
      surface2: '0.298 0.0252 255',
      surface2Hover: '0.338 0.0252 255',
      surface2Active: '0.367 0.0252 255',
      surface2Highlight: '0.348 0.0252 255',
      surface3: '0.283 0.0153 255',
      surface3Hover: '0.318 0.0153 255',
      surface3Active: '0.348 0.0153 255',
      surface3Highlight: '0.328 0.0153 255',
      surface4: '0.318 0.0054 255',
      surface4Hover: '0.357 0.0054 255',
      surface4Active: '0.386 0.0054 255',
      surface4Highlight: '0.367 0.0054 255',
      accent: '0.234 0.0562 251.2',
      accentForeground: '0.913 0.0443 248.3',
      accentHover: '0.298 0.0779 252.3',
      sidebarAccent: '0.569 0.13 255',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.211 0.0371 250',
      borderSubtle: '0.318 0.0138 248.3',
      borderDefault: '0.366 0.0167 248.3',
      borderMainContent: '0.325 0.0153 248.3',
      inputBg: '0.267 0.0108 248.2',
      inputBorder: '0.337 0.015 248.3',
      inputBorderHover: '0.394 0.0229 248.4',
      inputBorderFocus: '0.569 0.1944 256',
      inputBorderActive: '0.431 0.0256 248.4',
      inputBorderHighlight: '0.413 0.0243 248.4',
      inputBgActive: '0.298 0.0127 248.3',
      inputBgHighlight: '0.288 0.0121 248.2',
      inputBgDisabled: '0.246 0.008 248.2',
      inputPlaceholder: '0.577 0.0143 248.1',
      tabBg: '0.298 0.0105 248.2',
      tabBgHover: '0.338 0.0125 248.2',
      tabOutline: '0.414 0.0162 248.2',
      background: '0.154 0.0212 246.5',
      panelBackground: '0.189 0.0258 249.3',
      mainPanelBackground: '0.189 0.0258 249.3',
      ring: '0.569 0.2 255',
      contentPreviewBg: '0.235 0.022 248',
      contentPreviewFg: '0.7 0.025 248',
      contentPreviewBorder: '0.32 0.018 248',
    },
    surfaceScopesLight: {
      '0': {
        fg: '0.923 0 0',
        fgSecondary: '0.715 0 0',
        fgTertiary: '0.6 0 0',
        fgDisabled: '0.48 0 0',
        inputBg: '1 0 0',
        inputBorder: '0.883 0.0067 247.9',
        inputBorderHover: '0.826 0.012 248',
        inputBorderFocus: '0.826 0.012 248',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.785 0.0149 248',
        inputBorderHighlight: '0.825 0.015 248',
        inputBgActive: '0.977 0.001 247.8',
        inputBgHighlight: '0.977 0.002 247.8',
        inputBgDisabled: '0.961 0.0018 247.8',
        inputPlaceholder: '0.647 0.0106 248',
        tabBg: '0.914 0.0049 247.9',
        tabBgHover: '0.891 0.0062 247.9',
        tabOutline: '0.827 0.008 247.9',
        borderSubtle: '0.899 0.0058 247.9',
        borderDefault: '0.843 0.009 247.9',
      },
      '1': {
        inputBg: '1 0 0',
        inputBorder: '0.883 0.0067 247.9',
        inputBorderHover: '0.826 0.012 248',
        inputBorderFocus: '0.826 0.012 248',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.785 0.0149 248',
        inputBorderHighlight: '0.825 0.015 248',
        inputBgActive: '0.977 0.001 247.8',
        inputBgHighlight: '0.977 0.002 247.8',
        inputBgDisabled: '0.961 0.0018 247.8',
        inputPlaceholder: '0.647 0.0106 248',
        tabBg: '0.914 0.0049 247.9',
        tabBgHover: '0.891 0.0062 247.9',
        tabOutline: '0.827 0.008 247.9',
        borderSubtle: '0.899 0.0058 247.9',
        borderDefault: '0.843 0.009 247.9',
      },
      '2': {
        inputBg: '0.992 0.0004 247.8',
        inputBorder: '0.875 0.0072 247.9',
        inputBorderHover: '0.818 0.0126 248',
        inputBorderFocus: '0.818 0.0126 248',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.777 0.0155 248',
        inputBorderHighlight: '0.817 0.0157 248',
        inputBgActive: '0.969 0.0014 247.8',
        inputBgHighlight: '0.969 0.0026 247.8',
        inputBgDisabled: '0.954 0.0021 247.8',
        inputPlaceholder: '0.647 0.0106 248',
        tabBg: '0.899 0.0046 247.9',
        tabBgHover: '0.875 0.0057 247.9',
        tabOutline: '0.827 0.008 247.9',
        borderSubtle: '0.891 0.0062 247.9',
        borderDefault: '0.835 0.0095 247.9',
      },
      '3': {
        inputBg: '0.969 0.0017 247.8',
        inputBorder: '0.859 0.0081 247.9',
        inputBorderHover: '0.802 0.0137 248',
        inputBorderFocus: '0.802 0.0137 248',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.761 0.0167 248',
        inputBorderHighlight: '0.801 0.0172 248',
        inputBgActive: '0.946 0.0025 247.8',
        inputBgHighlight: '0.953 0.0039 247.9',
        inputBgDisabled: '0.946 0.0025 247.8',
        inputPlaceholder: '0.647 0.0106 248',
        tabBg: '0.954 0.0021 247.8',
        tabBgHover: '0.93 0.0032 247.9',
        tabOutline: '0.827 0.008 247.9',
        borderSubtle: '0.883 0.0067 247.9',
        borderDefault: '0.827 0.01 247.9',
      },
      '4': {
        inputBg: '0.969 0.0017 247.8',
        inputBorder: '0.859 0.0081 247.9',
        inputBorderHover: '0.802 0.0137 248',
        inputBorderFocus: '0.802 0.0137 248',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.761 0.0167 248',
        inputBorderHighlight: '0.801 0.0172 248',
        inputBgActive: '0.946 0.0025 247.8',
        inputBgHighlight: '0.953 0.0039 247.9',
        inputBgDisabled: '0.946 0.0025 247.8',
        inputPlaceholder: '0.647 0.0106 248',
        tabBg: '0.954 0.0021 247.8',
        tabBgHover: '0.93 0.0032 247.9',
        tabOutline: '0.827 0.008 247.9',
        borderSubtle: '0.883 0.0067 247.9',
        borderDefault: '0.827 0.01 247.9',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '0.203 0.007 248.2',
        inputBorder: '0.277 0.0115 248.2',
        inputBorderHover: '0.337 0.0187 248.4',
        inputBorderFocus: '0.337 0.0187 248.4',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.375 0.0215 248.4',
        inputBorderHighlight: '0.356 0.0201 248.4',
        inputBgActive: '0.235 0.009 248.2',
        inputBgHighlight: '0.225 0.0083 248.2',
        inputBgDisabled: '0.18 0.0047 248.1',
        inputPlaceholder: '0.577 0.0143 248.1',
        tabBg: '0.225 0.0069 248.1',
        tabBgHover: '0.267 0.009 248.2',
        tabOutline: '0.338 0.0125 248.2',
        borderSubtle: '0.246 0.0096 248.2',
        borderDefault: '0.298 0.0127 248.3',
      },
      '1': {
        inputBg: '0.235 0.009 248.2',
        inputBorder: '0.298 0.0127 248.3',
        inputBorderHover: '0.356 0.0201 248.4',
        inputBorderFocus: '0.356 0.0201 248.4',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.394 0.0229 248.4',
        inputBorderHighlight: '0.375 0.0215 248.4',
        inputBgActive: '0.267 0.0108 248.2',
        inputBgHighlight: '0.257 0.0102 248.2',
        inputBgDisabled: '0.214 0.0064 248.1',
        inputPlaceholder: '0.577 0.0143 248.1',
        tabBg: '0.257 0.0085 248.2',
        tabBgHover: '0.298 0.0105 248.2',
        tabOutline: '0.357 0.0134 248.2',
        borderSubtle: '0.277 0.0115 248.2',
        borderDefault: '0.328 0.0144 248.3',
      },
      '2': {
        inputBg: '0.337 0.015 248.3',
        inputBorder: '0.395 0.0183 248.3',
        inputBorderHover: '0.449 0.0269 248.4',
        inputBorderFocus: '0.449 0.0269 248.4',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.485 0.0295 248.4',
        inputBorderHighlight: '0.468 0.0282 248.4',
        inputBgActive: '0.366 0.0167 248.3',
        inputBgHighlight: '0.357 0.0161 248.3',
        inputBgDisabled: '0.278 0.0095 248.2',
        inputPlaceholder: '0.577 0.0143 248.1',
        tabBg: '0.357 0.0134 248.2',
        tabBgHover: '0.396 0.0153 248.2',
        tabOutline: '0.414 0.0162 248.2',
        borderSubtle: '0.376 0.0172 248.3',
        borderDefault: '0.414 0.0194 248.3',
      },
      '3': {
        inputBg: '0.318 0.0138 248.3',
        inputBorder: '0.376 0.0172 248.3',
        inputBorderHover: '0.431 0.0256 248.4',
        inputBorderFocus: '0.431 0.0256 248.4',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.468 0.0282 248.4',
        inputBorderHighlight: '0.449 0.0269 248.4',
        inputBgActive: '0.347 0.0156 248.3',
        inputBgHighlight: '0.337 0.015 248.3',
        inputBgDisabled: '0.257 0.0085 248.2',
        inputPlaceholder: '0.577 0.0143 248.1',
        tabBg: '0.338 0.0125 248.2',
        tabBgHover: '0.377 0.0144 248.2',
        tabOutline: '0.396 0.0153 248.2',
        borderSubtle: '0.357 0.0161 248.3',
        borderDefault: '0.395 0.0183 248.3',
      },
      '4': {
        inputBg: '0.357 0.0161 248.3',
        inputBorder: '0.414 0.0194 248.3',
        inputBorderHover: '0.468 0.0282 248.4',
        inputBorderFocus: '0.468 0.0282 248.4',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.503 0.0308 248.4',
        inputBorderHighlight: '0.485 0.0295 248.4',
        inputBgActive: '0.386 0.0178 248.3',
        inputBgHighlight: '0.376 0.0172 248.3',
        inputBgDisabled: '0.298 0.0105 248.2',
        inputPlaceholder: '0.577 0.0143 248.1',
        tabBg: '0.377 0.0144 248.2',
        tabBgHover: '0.414 0.0162 248.2',
        tabOutline: '0.433 0.0171 248.2',
        borderSubtle: '0.395 0.0183 248.3',
        borderDefault: '0.432 0.0205 248.3',
      },
    },
  },

  forest: {
    light: {
      surface0: '0.22 0.045 158.4',
      surface0Hover: '0.26 0.05 158',
      surface0Active: '0.3 0.055 158',
      surface0Highlight: '0.28 0.052 158',
      surface1: '1 0 0',
      surface1Hover: '0.974 0.011 158.5',
      surface1Active: '0.955 0.0193 158.3',
      surface1Highlight: '0.968 0.0137 158.4',
      surface2: '0.934 0.0062 158.6',
      surface2Hover: '0.949 0.0048 158.6',
      surface2Active: '0.919 0.0077 158.5',
      surface2Highlight: '0.935 0.0094 158.5',
      surface3: '1 0 0',
      surface3Hover: '0.978 0.0021 158.7',
      surface3Active: '0.956 0.0041 158.6',
      surface3Highlight: '0.971 0.0041 158.6',
      surface4: '0.985 0.003 155',
      surface4Hover: '0.965 0.004 155',
      surface4Active: '0.945 0.005 155',
      surface4Highlight: '0.96 0.006 155',
      accent: '0.951 0.0275 158.1',
      accentForeground: '0.402 0.1005 150.5',
      accentHover: '0.909 0.0516 157.4',
      sidebarAccent: '0.48 0.12 155',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.28 0.055 158',
      borderSubtle: '0.904 0.0091 158.5',
      borderDefault: '0.851 0.0142 158.4',
      borderMainContent: '0.897 0.0117 158.5',
      inputBg: '1 0 0',
      inputBorder: '0.904 0.0091 158.5',
      inputBorderHover: '0.853 0.017 158.3',
      inputBorderFocus: '0.65 0.1733 149.7',
      inputBorderActive: '0.815 0.0214 158.1',
      inputBorderHighlight: '0.854 0.0212 158.2',
      inputBgActive: '0.978 0.0016 158.7',
      inputBgHighlight: '0.978 0.0031 158.7',
      inputBgDisabled: '0.97 0.0022 158.7',
      inputPlaceholder: '0.657 0.0166 158.2',
      tabBg: '0.919 0.0077 158.5',
      tabBgHover: '0.897 0.0098 158.5',
      tabOutline: '0.835 0.0125 158.4',
      background: '0.22 0.045 158',
      panelBackground: '1 0 0',
      mainPanelBackground: '1 0 0',
      ring: '0.658 0.2 155',
      contentPreviewBg: '0.93 0.012 158',
      contentPreviewFg: '0.45 0.04 158',
      contentPreviewBorder: '0.86 0.018 158',
    },
    dark: {
      surface0: '0.156 0.0216 157.2',
      surface0Hover: '0.202 0.0331 154.4',
      surface0Active: '0.244 0.0444 153.7',
      surface0Highlight: '0.216 0.0369 154.1',
      surface1: '0.197 0.0271 155.2',
      surface1Hover: '0.237 0.0366 154.7',
      surface1Active: '0.276 0.0454 154.3',
      surface1Highlight: '0.25 0.0396 154.6',
      surface2: '0.308 0.0224 155',
      surface2Hover: '0.35 0.0224 155',
      surface2Active: '0.381 0.0224 155',
      surface2Highlight: '0.36 0.0224 155',
      surface3: '0.292 0.0136 155',
      surface3Hover: '0.329 0.0136 155',
      surface3Active: '0.36 0.0136 155',
      surface3Highlight: '0.34 0.0136 155',
      surface4: '0.329 0.005 155',
      surface4Hover: '0.37 0.005 155',
      surface4Active: '0.401 0.005 155',
      surface4Highlight: '0.381 0.005 155',
      accent: '0.237 0.0366 154.7',
      accentForeground: '0.914 0.0616 157.2',
      accentHover: '0.314 0.0538 154.1',
      sidebarAccent: '0.48 0.12 155',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.211 0.0304 155',
      borderSubtle: '0.331 0.0212 157.2',
      borderDefault: '0.383 0.0255 157.2',
      borderMainContent: '0.338 0.0234 157.2',
      inputBg: '0.278 0.0166 157.3',
      inputBorder: '0.352 0.023 157.2',
      inputBorderHover: '0.417 0.0348 156.8',
      inputBorderFocus: '0.574 0.1396 150.9',
      inputBorderActive: '0.457 0.0388 156.7',
      inputBorderHighlight: '0.437 0.0368 156.7',
      inputBgActive: '0.31 0.0194 157.3',
      inputBgHighlight: '0.299 0.0185 157.3',
      inputBgDisabled: '0.254 0.0123 157.6',
      inputPlaceholder: '0.591 0.0222 157.9',
      tabBg: '0.308 0.0163 157.5',
      tabBgHover: '0.35 0.0192 157.5',
      tabOutline: '0.43 0.0249 157.4',
      background: '0.156 0.0216 157.2',
      panelBackground: '0.197 0.0271 155.2',
      mainPanelBackground: '0.197 0.0271 155.2',
      ring: '0.574 0.2 155',
      contentPreviewBg: '0.235 0.025 155',
      contentPreviewFg: '0.7 0.03 155',
      contentPreviewBorder: '0.32 0.025 155',
    },
    surfaceScopesLight: {
      '0': {
        fg: '0.923 0 0',
        fgSecondary: '0.715 0 0',
        fgTertiary: '0.6 0 0',
        fgDisabled: '0.48 0 0',
        inputBg: '1 0 0',
        inputBorder: '0.889 0.0105 158.5',
        inputBorderHover: '0.838 0.0187 158.2',
        inputBorderFocus: '0.838 0.0187 158.2',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.8 0.0232 158.1',
        inputBorderHighlight: '0.84 0.0234 158.1',
        inputBgActive: '0.978 0.0016 158.7',
        inputBgHighlight: '0.978 0.0031 158.7',
        inputBgDisabled: '0.963 0.0028 158.7',
        inputPlaceholder: '0.657 0.0166 158.2',
        tabBg: '0.919 0.0077 158.5',
        tabBgHover: '0.897 0.0098 158.5',
        tabOutline: '0.835 0.0125 158.4',
        borderSubtle: '0.904 0.0091 158.5',
        borderDefault: '0.851 0.0142 158.4',
      },
      '1': {
        inputBg: '1 0 0',
        inputBorder: '0.889 0.0105 158.5',
        inputBorderHover: '0.838 0.0187 158.2',
        inputBorderFocus: '0.838 0.0187 158.2',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.8 0.0232 158.1',
        inputBorderHighlight: '0.84 0.0234 158.1',
        inputBgActive: '0.978 0.0016 158.7',
        inputBgHighlight: '0.978 0.0031 158.7',
        inputBgDisabled: '0.963 0.0028 158.7',
        inputPlaceholder: '0.657 0.0166 158.2',
        tabBg: '0.919 0.0077 158.5',
        tabBgHover: '0.897 0.0098 158.5',
        tabOutline: '0.835 0.0125 158.4',
        borderSubtle: '0.904 0.0091 158.5',
        borderDefault: '0.851 0.0142 158.4',
      },
      '2': {
        inputBg: '0.993 0.0007 158.7',
        inputBorder: '0.881 0.0112 158.4',
        inputBorderHover: '0.83 0.0196 158.2',
        inputBorderFocus: '0.83 0.0196 158.2',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.792 0.0241 158',
        inputBorderHighlight: '0.832 0.0245 158.1',
        inputBgActive: '0.97 0.0022 158.7',
        inputBgHighlight: '0.971 0.0041 158.6',
        inputBgDisabled: '0.956 0.0033 158.6',
        inputPlaceholder: '0.657 0.0166 158.2',
        tabBg: '0.903 0.0073 158.5',
        tabBgHover: '0.881 0.009 158.5',
        tabOutline: '0.835 0.0125 158.4',
        borderSubtle: '0.897 0.0098 158.5',
        borderDefault: '0.844 0.0149 158.3',
      },
      '3': {
        inputBg: '0.971 0.0028 158.7',
        inputBorder: '0.866 0.0127 158.4',
        inputBorderHover: '0.815 0.0214 158.1',
        inputBorderFocus: '0.815 0.0214 158.1',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.777 0.026 158',
        inputBorderHighlight: '0.817 0.0267 158',
        inputBgActive: '0.948 0.0039 158.6',
        inputBgHighlight: '0.957 0.0062 158.6',
        inputBgDisabled: '0.948 0.0039 158.6',
        inputPlaceholder: '0.657 0.0166 158.2',
        tabBg: '0.956 0.0033 158.6',
        tabBgHover: '0.933 0.005 158.6',
        tabOutline: '0.835 0.0125 158.4',
        borderSubtle: '0.889 0.0105 158.5',
        borderDefault: '0.836 0.0156 158.3',
      },
      '4': {
        inputBg: '0.971 0.0028 158.7',
        inputBorder: '0.866 0.0127 158.4',
        inputBorderHover: '0.815 0.0214 158.1',
        inputBorderFocus: '0.815 0.0214 158.1',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.777 0.026 158',
        inputBorderHighlight: '0.817 0.0267 158',
        inputBgActive: '0.948 0.0039 158.6',
        inputBgHighlight: '0.957 0.0062 158.6',
        inputBgDisabled: '0.948 0.0039 158.6',
        inputPlaceholder: '0.657 0.0166 158.2',
        tabBg: '0.956 0.0033 158.6',
        tabBgHover: '0.933 0.005 158.6',
        tabOutline: '0.835 0.0125 158.4',
        borderSubtle: '0.889 0.0105 158.5',
        borderDefault: '0.836 0.0156 158.3',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '0.198 0.0097 157.6',
        inputBorder: '0.266 0.0157 157.4',
        inputBorderHover: '0.334 0.0263 156.9',
        inputBorderFocus: '0.334 0.0263 156.9',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.376 0.0306 156.8',
        inputBorderHighlight: '0.355 0.0285 156.8',
        inputBgActive: '0.233 0.0128 157.5',
        inputBgHighlight: '0.221 0.0118 157.5',
        inputBgDisabled: '0.173 0.0063 157.9',
        inputPlaceholder: '0.591 0.0222 157.9',
        tabBg: '0.22 0.0099 157.7',
        tabBgHover: '0.265 0.0131 157.6',
        tabOutline: '0.329 0.0178 157.5',
        borderSubtle: '0.244 0.0138 157.4',
        borderDefault: '0.299 0.0185 157.3',
      },
      '1': {
        inputBg: '0.233 0.0128 157.5',
        inputBorder: '0.299 0.0185 157.3',
        inputBorderHover: '0.366 0.0295 156.8',
        inputBorderFocus: '0.366 0.0295 156.8',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.407 0.0337 156.8',
        inputBorderHighlight: '0.386 0.0317 156.8',
        inputBgActive: '0.266 0.0157 157.4',
        inputBgHighlight: '0.255 0.0147 157.4',
        inputBgDisabled: '0.208 0.009 157.8',
        inputPlaceholder: '0.591 0.0222 157.9',
        tabBg: '0.254 0.0123 157.6',
        tabBgHover: '0.298 0.0155 157.5',
        tabOutline: '0.36 0.02 157.5',
        borderSubtle: '0.278 0.0166 157.3',
        borderDefault: '0.331 0.0212 157.2',
      },
      '2': {
        inputBg: '0.352 0.023 157.2',
        inputBorder: '0.413 0.0281 157.2',
        inputBorderHover: '0.476 0.0408 156.7',
        inputBorderFocus: '0.476 0.0408 156.7',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.515 0.0447 156.7',
        inputBorderHighlight: '0.496 0.0427 156.7',
        inputBgActive: '0.383 0.0255 157.2',
        inputBgHighlight: '0.373 0.0247 157.2',
        inputBgDisabled: '0.287 0.0147 157.6',
        inputPlaceholder: '0.591 0.0222 157.9',
        tabBg: '0.37 0.0207 157.4',
        tabBgHover: '0.41 0.0235 157.4',
        tabOutline: '0.43 0.0249 157.4',
        borderSubtle: '0.393 0.0264 157.2',
        borderDefault: '0.433 0.0297 157.1',
      },
      '3': {
        inputBg: '0.331 0.0212 157.2',
        inputBorder: '0.393 0.0264 157.2',
        inputBorderHover: '0.457 0.0388 156.7',
        inputBorderFocus: '0.457 0.0388 156.7',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.496 0.0427 156.7',
        inputBorderHighlight: '0.476 0.0408 156.7',
        inputBgActive: '0.362 0.0238 157.2',
        inputBgHighlight: '0.352 0.023 157.2',
        inputBgDisabled: '0.265 0.0131 157.6',
        inputPlaceholder: '0.591 0.0222 157.9',
        tabBg: '0.35 0.0192 157.5',
        tabBgHover: '0.391 0.0221 157.4',
        tabOutline: '0.41 0.0235 157.4',
        borderSubtle: '0.373 0.0247 157.2',
        borderDefault: '0.413 0.0281 157.2',
      },
      '4': {
        inputBg: '0.373 0.0247 157.2',
        inputBorder: '0.433 0.0297 157.1',
        inputBorderHover: '0.496 0.0427 156.7',
        inputBorderFocus: '0.496 0.0427 156.7',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.534 0.0466 156.7',
        inputBorderHighlight: '0.515 0.0447 156.7',
        inputBgActive: '0.403 0.0272 157.2',
        inputBgHighlight: '0.393 0.0264 157.2',
        inputBgDisabled: '0.308 0.0163 157.5',
        inputPlaceholder: '0.591 0.0222 157.9',
        tabBg: '0.391 0.0221 157.4',
        tabBgHover: '0.43 0.0249 157.4',
        tabOutline: '0.45 0.0263 157.4',
        borderSubtle: '0.413 0.0281 157.2',
        borderDefault: '0.452 0.0313 157.1',
      },
    },
  },

  berry: {
    light: {
      surface0: '0.22 0.05 314.8',
      surface0Hover: '0.26 0.055 315',
      surface0Active: '0.3 0.06 315',
      surface0Highlight: '0.28 0.057 315',
      surface1: '1 0 0',
      surface1Hover: '0.962 0.0153 314.7',
      surface1Active: '0.934 0.0269 314.7',
      surface1Highlight: '0.953 0.0192 314.7',
      surface2: '0.928 0.0069 314.8',
      surface2Hover: '0.944 0.0054 314.8',
      surface2Active: '0.912 0.0085 314.8',
      surface2Highlight: '0.926 0.0104 314.8',
      surface3: '1 0 0',
      surface3Hover: '0.976 0.0023 314.8',
      surface3Active: '0.952 0.0046 314.8',
      surface3Highlight: '0.967 0.0046 314.8',
      surface4: '0.985 0.003 300',
      surface4Hover: '0.965 0.004 300',
      surface4Active: '0.945 0.005 300',
      surface4Highlight: '0.96 0.006 300',
      accent: '0.937 0.0369 314.6',
      accentForeground: '0.385 0.1821 309.9',
      accentHover: '0.876 0.0748 314.4',
      sidebarAccent: '0.53 0.14 300',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.28 0.06 315',
      borderSubtle: '0.895 0.0101 314.8',
      borderDefault: '0.838 0.0158 314.7',
      borderMainContent: '0.888 0.013 314.8',
      inputBg: '1 0 0',
      inputBorder: '0.895 0.0101 314.8',
      inputBorderHover: '0.836 0.019 314.7',
      inputBorderFocus: '0.58 0.2361 311.6',
      inputBorderActive: '0.794 0.0241 314.7',
      inputBorderHighlight: '0.834 0.0238 314.7',
      inputBgActive: '0.976 0.0018 314.8',
      inputBgHighlight: '0.976 0.0034 314.8',
      inputBgDisabled: '0.968 0.0024 314.8',
      inputPlaceholder: '0.641 0.0186 314.7',
      tabBg: '0.912 0.0085 314.8',
      tabBgHover: '0.887 0.0109 314.8',
      tabOutline: '0.823 0.014 314.7',
      background: '0.22 0.05 315',
      panelBackground: '1 0 0',
      mainPanelBackground: '1 0 0',
      ring: '0.58 0.2361 300',
      contentPreviewBg: '0.93 0.012 305',
      contentPreviewFg: '0.45 0.04 305',
      contentPreviewBorder: '0.86 0.018 305',
    },
    dark: {
      surface0: '0.139 0.0362 306.8',
      surface0Hover: '0.169 0.0509 304.7',
      surface0Active: '0.197 0.0658 304',
      surface0Highlight: '0.179 0.0559 304.4',
      surface1: '0.172 0.0429 305.4',
      surface1Hover: '0.2 0.0561 305',
      surface1Active: '0.227 0.0685 304.6',
      surface1Highlight: '0.209 0.0603 304.8',
      surface2: '0.291 0.0252 300',
      surface2Hover: '0.329 0.0252 300',
      surface2Active: '0.358 0.0252 300',
      surface2Highlight: '0.339 0.0252 300',
      surface3: '0.276 0.0153 300',
      surface3Hover: '0.31 0.0153 300',
      surface3Active: '0.339 0.0153 300',
      surface3Highlight: '0.32 0.0153 300',
      surface4: '0.31 0.0054 300',
      surface4Hover: '0.348 0.0054 300',
      surface4Active: '0.376 0.0054 300',
      surface4Highlight: '0.358 0.0054 300',
      accent: '0.217 0.0625 313.1',
      accentForeground: '0.899 0.0543 314.5',
      accentHover: '0.273 0.0871 312.8',
      sidebarAccent: '0.502 0.13 300',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.197 0.0537 313.3',
      borderSubtle: '0.308 0.0232 307.6',
      borderDefault: '0.355 0.0279 307.6',
      borderMainContent: '0.315 0.0256 307.6',
      inputBg: '0.26 0.0181 307.7',
      inputBorder: '0.327 0.0251 307.6',
      inputBorderHover: '0.379 0.0384 307.3',
      inputBorderFocus: '0.502 0.2082 311.5',
      inputBorderActive: '0.414 0.0429 307.3',
      inputBorderHighlight: '0.396 0.0406 307.3',
      inputBgActive: '0.289 0.0212 307.6',
      inputBgHighlight: '0.279 0.0202 307.7',
      inputBgDisabled: '0.241 0.0134 307.8',
      inputPlaceholder: '0.567 0.0239 308',
      tabBg: '0.291 0.0176 307.8',
      tabBgHover: '0.329 0.0209 307.8',
      tabOutline: '0.403 0.0271 307.7',
      background: '0.139 0.0362 306.8',
      panelBackground: '0.172 0.0429 305.4',
      mainPanelBackground: '0.172 0.0429 305.4',
      ring: '0.502 0.2082 300',
      contentPreviewBg: '0.21 0.045 306',
      contentPreviewFg: '0.7 0.04 306',
      contentPreviewBorder: '0.3 0.04 306',
    },
    surfaceScopesLight: {
      '0': {
        fg: '0.923 0 0',
        fgSecondary: '0.715 0 0',
        fgTertiary: '0.6 0 0',
        fgDisabled: '0.48 0 0',
        inputBg: '1 0 0',
        inputBorder: '0.879 0.0117 314.8',
        inputBorderHover: '0.82 0.021 314.7',
        inputBorderFocus: '0.82 0.021 314.7',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.777 0.0261 314.7',
        inputBorderHighlight: '0.817 0.0263 314.7',
        inputBgActive: '0.976 0.0018 314.8',
        inputBgHighlight: '0.976 0.0034 314.8',
        inputBgDisabled: '0.96 0.0031 314.8',
        inputPlaceholder: '0.641 0.0186 314.7',
        tabBg: '0.912 0.0085 314.8',
        tabBgHover: '0.887 0.0109 314.8',
        tabOutline: '0.823 0.014 314.7',
        borderSubtle: '0.895 0.0101 314.8',
        borderDefault: '0.838 0.0158 314.7',
      },
      '1': {
        inputBg: '1 0 0',
        inputBorder: '0.879 0.0117 314.8',
        inputBorderHover: '0.82 0.021 314.7',
        inputBorderFocus: '0.82 0.021 314.7',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.777 0.0261 314.7',
        inputBorderHighlight: '0.817 0.0263 314.7',
        inputBgActive: '0.976 0.0018 314.8',
        inputBgHighlight: '0.976 0.0034 314.8',
        inputBgDisabled: '0.96 0.0031 314.8',
        inputPlaceholder: '0.641 0.0186 314.7',
        tabBg: '0.912 0.0085 314.8',
        tabBgHover: '0.887 0.0109 314.8',
        tabOutline: '0.823 0.014 314.7',
        borderSubtle: '0.895 0.0101 314.8',
        borderDefault: '0.838 0.0158 314.7',
      },
      '2': {
        inputBg: '0.992 0.0008 314.8',
        inputBorder: '0.871 0.0125 314.8',
        inputBorderHover: '0.811 0.022 314.7',
        inputBorderFocus: '0.811 0.022 314.7',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.769 0.0272 314.7',
        inputBorderHighlight: '0.809 0.0275 314.7',
        inputBgActive: '0.968 0.0024 314.8',
        inputBgHighlight: '0.967 0.0046 314.8',
        inputBgDisabled: '0.952 0.0037 314.8',
        inputPlaceholder: '0.641 0.0186 314.7',
        tabBg: '0.896 0.0081 314.8',
        tabBgHover: '0.872 0.01 314.8',
        tabOutline: '0.823 0.014 314.7',
        borderSubtle: '0.887 0.0109 314.8',
        borderDefault: '0.83 0.0167 314.7',
      },
      '3': {
        inputBg: '0.968 0.0031 314.8',
        inputBorder: '0.854 0.0142 314.7',
        inputBorderHover: '0.794 0.0241 314.7',
        inputBorderFocus: '0.794 0.0241 314.7',
        inputBorderActive: '0.752 0.0293 314.6',
        inputBorderHighlight: '0.792 0.0301 314.6',
        inputBorderError: '0.636 0.2082 25.4',
        inputBgActive: '0.945 0.0043 314.8',
        inputBgHighlight: '0.951 0.0069 314.8',
        inputBgDisabled: '0.945 0.0043 314.8',
        inputPlaceholder: '0.641 0.0186 314.7',
        tabBg: '0.952 0.0037 314.8',
        tabBgHover: '0.929 0.0056 314.8',
        tabOutline: '0.823 0.014 314.7',
        borderSubtle: '0.879 0.0117 314.8',
        borderDefault: '0.821 0.0175 314.7',
      },
      '4': {
        inputBg: '0.968 0.0031 314.8',
        inputBorder: '0.854 0.0142 314.7',
        inputBorderHover: '0.794 0.0241 314.7',
        inputBorderFocus: '0.794 0.0241 314.7',
        inputBorderActive: '0.752 0.0293 314.6',
        inputBorderHighlight: '0.792 0.0301 314.6',
        inputBorderError: '0.636 0.2082 25.4',
        inputBgActive: '0.945 0.0043 314.8',
        inputBgHighlight: '0.951 0.0069 314.8',
        inputBgDisabled: '0.945 0.0043 314.8',
        inputPlaceholder: '0.641 0.0186 314.7',
        tabBg: '0.952 0.0037 314.8',
        tabBgHover: '0.929 0.0056 314.8',
        tabOutline: '0.823 0.014 314.7',
        borderSubtle: '0.879 0.0117 314.8',
        borderDefault: '0.821 0.0175 314.7',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '0.198 0.0117 307.8',
        inputBorder: '0.269 0.0192 307.7',
        inputBorderHover: '0.324 0.0314 307.4',
        inputBorderFocus: '0.324 0.0314 307.4',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.361 0.0361 307.3',
        inputBorderHighlight: '0.342 0.0337 307.4',
        inputBgActive: '0.229 0.015 307.7',
        inputBgHighlight: '0.219 0.0139 307.8',
        inputBgDisabled: '0.177 0.0078 308',
        inputPlaceholder: '0.567 0.0239 308',
        tabBg: '0.22 0.0116 307.9',
        tabBgHover: '0.261 0.0151 307.8',
        tabOutline: '0.329 0.0209 307.8',
        borderSubtle: '0.239 0.016 307.7',
        borderDefault: '0.289 0.0212 307.6',
      },
      '1': {
        inputBg: '0.229 0.015 307.7',
        inputBorder: '0.289 0.0212 307.6',
        inputBorderHover: '0.342 0.0337 307.4',
        inputBorderFocus: '0.342 0.0337 307.4',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.379 0.0384 307.3',
        inputBorderHighlight: '0.361 0.0361 307.3',
        inputBgActive: '0.26 0.0181 307.7',
        inputBgHighlight: '0.25 0.0171 307.7',
        inputBgDisabled: '0.21 0.0106 307.9',
        inputPlaceholder: '0.567 0.0239 308',
        tabBg: '0.251 0.0142 307.8',
        tabBgHover: '0.291 0.0176 307.8',
        tabOutline: '0.348 0.0225 307.7',
        borderSubtle: '0.269 0.0192 307.7',
        borderDefault: '0.318 0.0241 307.6',
      },
      '2': {
        inputBg: '0.327 0.0251 307.6',
        inputBorder: '0.382 0.0307 307.6',
        inputBorderHover: '0.431 0.0451 307.3',
        inputBorderFocus: '0.431 0.0451 307.3',
        inputBorderActive: '0.466 0.0494 307.3',
        inputBorderHighlight: '0.448 0.0473 307.3',
        inputBorderError: '0.562 0.1966 26.3',
        inputBgActive: '0.355 0.0279 307.6',
        inputBgHighlight: '0.346 0.027 307.6',
        inputBgDisabled: '0.271 0.016 307.8',
        inputPlaceholder: '0.567 0.0239 308',
        tabBg: '0.348 0.0225 307.7',
        tabBgHover: '0.385 0.0256 307.7',
        tabOutline: '0.403 0.0271 307.7',
        borderSubtle: '0.364 0.0289 307.6',
        borderDefault: '0.4 0.0325 307.6',
      },
      '3': {
        inputBg: '0.308 0.0232 307.6',
        inputBorder: '0.364 0.0289 307.6',
        inputBorderHover: '0.414 0.0429 307.3',
        inputBorderFocus: '0.414 0.0429 307.3',
        inputBorderActive: '0.448 0.0473 307.3',
        inputBorderHighlight: '0.431 0.0451 307.3',
        inputBorderError: '0.562 0.1966 26.3',
        inputBgActive: '0.337 0.026 307.6',
        inputBgHighlight: '0.327 0.0251 307.6',
        inputBgDisabled: '0.251 0.0142 307.8',
        inputPlaceholder: '0.567 0.0239 308',
        tabBg: '0.329 0.0209 307.8',
        tabBgHover: '0.367 0.024 307.7',
        tabOutline: '0.385 0.0256 307.7',
        borderSubtle: '0.346 0.027 307.6',
        borderDefault: '0.382 0.0307 307.6',
      },
      '4': {
        inputBg: '0.346 0.027 307.6',
        inputBorder: '0.4 0.0325 307.6',
        inputBorderHover: '0.448 0.0473 307.3',
        inputBorderFocus: '0.448 0.0473 307.3',
        inputBorderActive: '0.482 0.0516 307.3',
        inputBorderHighlight: '0.466 0.0494 307.3',
        inputBorderError: '0.562 0.1966 26.3',
        inputBgActive: '0.373 0.0298 307.6',
        inputBgHighlight: '0.364 0.0289 307.6',
        inputBgDisabled: '0.291 0.0176 307.8',
        inputPlaceholder: '0.567 0.0239 308',
        tabBg: '0.367 0.024 307.7',
        tabBgHover: '0.403 0.0271 307.7',
        tabOutline: '0.421 0.0286 307.7',
        borderSubtle: '0.382 0.0307 307.6',
        borderDefault: '0.418 0.0343 307.6',
      },
    },
  },

  sand: {
    light: {
      surface0: '0.942 0.0059 84.6',
      surface0Hover: '0.939 0.0165 76.6',
      surface0Active: '0.918 0.0221 76.5',
      surface0Highlight: '0.932 0.0184 76.5',
      surface1: '1 0 0',
      surface1Hover: '0.965 0.0069 76.6',
      surface1Active: '0.944 0.011 76.6',
      surface1Highlight: '0.958 0.0082 76.6',
      surface2: '0.933 0.005 76.6',
      surface2Hover: '0.948 0.0039 76.6',
      surface2Active: '0.918 0.0061 76.6',
      surface2Highlight: '0.935 0.0075 76.6',
      surface3: '1 0 0',
      surface3Hover: '0.978 0.0021 76.6',
      surface3Active: '0.956 0.0041 76.6',
      surface3Highlight: '0.971 0.0037 76.6',
      surface4: '0.985 0.003 60',
      surface4Hover: '0.965 0.004 60',
      surface4Active: '0.945 0.005 60',
      surface4Highlight: '0.96 0.006 60',
      accent: '0.947 0.0183 76.6',
      accentForeground: '0.345 0.0535 64.4',
      accentHover: '0.908 0.0322 76.4',
      sidebarAccent: '0.45 0.15 60',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.932 0.0184 76.5',
      borderSubtle: '0.896 0.0078 76.6',
      borderDefault: '0.835 0.0125 76.6',
      borderMainContent: '0.889 0.0102 76.6',
      inputBg: '1 0 0',
      inputBorder: '0.896 0.0078 76.6',
      inputBorderHover: '0.836 0.0146 76.6',
      inputBorderFocus: '0.61 0.1115 62.8',
      inputBorderActive: '0.798 0.0181 76.5',
      inputBorderHighlight: '0.838 0.0187 76.5',
      inputBgActive: '0.978 0.0016 76.6',
      inputBgHighlight: '0.978 0.0027 76.6',
      inputBgDisabled: '0.963 0.0023 76.6',
      inputPlaceholder: '0.649 0.0181 76.5',
      tabBg: '0.911 0.0067 76.6',
      tabBgHover: '0.881 0.009 76.6',
      tabOutline: '0.819 0.0114 76.6',
      background: '0.942 0.0059 84.6',
      panelBackground: '1 0 0',
      mainPanelBackground: '1 0 0',
      ring: '0.61 0.15 60',
      contentPreviewBg: '0.9 0.006 84.6',
      contentPreviewFg: '0.45 0.012 84.6',
      contentPreviewBorder: '0.85 0.008 84.6',
    },
    dark: {
      surface0: '0.176 0.0158 66.6',
      surface0Hover: '0.213 0.0224 66.1',
      surface0Active: '0.249 0.0286 65.9',
      surface0Highlight: '0.225 0.0245 66',
      surface1: '0.21 0.017 66.7',
      surface1Hover: '0.246 0.0218 66.5',
      surface1Active: '0.279 0.0263 66.4',
      surface1Highlight: '0.257 0.0233 66.5',
      surface2: '0.306 0.018 60',
      surface2Hover: '0.347 0.018 60',
      surface2Active: '0.377 0.018 60',
      surface2Highlight: '0.357 0.018 60',
      surface3: '0.29 0.012 60',
      surface3Hover: '0.326 0.012 60',
      surface3Active: '0.357 0.012 60',
      surface3Highlight: '0.337 0.012 60',
      surface4: '0.326 0.006 60',
      surface4Hover: '0.367 0.006 60',
      surface4Active: '0.397 0.006 60',
      surface4Highlight: '0.377 0.006 60',
      accent: '0.276 0.0399 64.9',
      accentForeground: '0.924 0.033 76.4',
      accentHover: '0.345 0.0535 64.4',
      sidebarAccent: '0.44 0.15 60',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.237 0.0266 66',
      borderSubtle: '0.326 0.016 67.2',
      borderDefault: '0.387 0.0199 67.2',
      borderMainContent: '0.333 0.018 67.2',
      inputBg: '0.274 0.0125 67.3',
      inputBorder: '0.347 0.0173 67.2',
      inputBorderHover: '0.408 0.0241 67.1',
      inputBorderFocus: '0.566 0.1088 62.1',
      inputBorderActive: '0.446 0.0269 67',
      inputBorderHighlight: '0.427 0.0255 67.1',
      inputBgActive: '0.306 0.0146 67.2',
      inputBgHighlight: '0.295 0.0139 67.2',
      inputBgDisabled: '0.251 0.0095 67.4',
      inputPlaceholder: '0.587 0.019 67.4',
      tabBg: '0.305 0.0125 67.3',
      tabBgHover: '0.346 0.0149 67.3',
      tabOutline: '0.425 0.0192 67.3',
      background: '0.176 0.0158 66.6',
      panelBackground: '0.21 0.017 66.7',
      mainPanelBackground: '0.21 0.017 66.7',
      ring: '0.566 0.15 60',
      contentPreviewBg: '0.245 0.02 67',
      contentPreviewFg: '0.7 0.022 67',
      contentPreviewBorder: '0.32 0.022 67',
    },
    surfaceScopesLight: {
      '0': {
        inputBg: '1 0 0',
        inputBorder: '0.881 0.009 76.6',
        inputBorderHover: '0.829 0.0153 76.6',
        inputBorderFocus: '0.829 0.0153 76.6',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.79 0.0188 76.5',
        inputBorderHighlight: '0.831 0.0196 76.5',
        inputBgActive: '0.978 0.0014 76.6',
        inputBgHighlight: '0.978 0.0025 76.6',
        inputBgDisabled: '0.963 0.0023 76.6',
        inputPlaceholder: '0.649 0.0181 76.5',
        tabBg: '0.911 0.0067 76.6',
        tabBgHover: '0.881 0.009 76.6',
        tabOutline: '0.819 0.0114 76.6',
        borderSubtle: '0.896 0.0078 76.6',
        borderDefault: '0.835 0.0125 76.6',
      },
      '1': {
        inputBg: '1 0 0',
        inputBorder: '0.881 0.009 76.6',
        inputBorderHover: '0.829 0.0153 76.6',
        inputBorderFocus: '0.829 0.0153 76.6',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.79 0.0188 76.5',
        inputBorderHighlight: '0.831 0.0196 76.5',
        inputBgActive: '0.978 0.0014 76.6',
        inputBgHighlight: '0.978 0.0025 76.6',
        inputBgDisabled: '0.963 0.0023 76.6',
        inputPlaceholder: '0.649 0.0181 76.5',
        tabBg: '0.911 0.0067 76.6',
        tabBgHover: '0.881 0.009 76.6',
        tabOutline: '0.819 0.0114 76.6',
        borderSubtle: '0.896 0.0078 76.6',
        borderDefault: '0.835 0.0125 76.6',
      },
      '2': {
        inputBg: '0.993 0.0005 76.6',
        inputBorder: '0.873 0.0096 76.6',
        inputBorderHover: '0.821 0.0159 76.6',
        inputBorderFocus: '0.821 0.0159 76.6',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.782 0.0195 76.5',
        inputBorderHighlight: '0.823 0.0205 76.5',
        inputBgActive: '0.97 0.0018 76.6',
        inputBgHighlight: '0.971 0.0033 76.6',
        inputBgDisabled: '0.955 0.0028 76.6',
        inputPlaceholder: '0.649 0.0181 76.5',
        tabBg: '0.895 0.0065 76.6',
        tabBgHover: '0.873 0.008 76.6',
        tabOutline: '0.819 0.0114 76.6',
        borderSubtle: '0.888 0.0084 76.6',
        borderDefault: '0.827 0.0131 76.6',
      },
      '3': {
        inputBg: '0.963 0.0027 76.6',
        inputBorder: '0.858 0.0107 76.6',
        inputBorderHover: '0.806 0.0173 76.5',
        inputBorderFocus: '0.806 0.0173 76.5',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.767 0.0209 76.5',
        inputBorderHighlight: '0.808 0.0222 76.5',
        inputBgActive: '0.941 0.0037 76.6',
        inputBgHighlight: '0.949 0.0058 76.6',
        inputBgDisabled: '0.941 0.0037 76.6',
        inputPlaceholder: '0.649 0.0181 76.5',
        tabBg: '0.948 0.0032 76.6',
        tabBgHover: '0.926 0.0046 76.6',
        tabOutline: '0.819 0.0114 76.6',
        borderSubtle: '0.881 0.009 76.6',
        borderDefault: '0.82 0.0137 76.6',
      },
      '4': {
        inputBg: '0.963 0.0027 76.6',
        inputBorder: '0.858 0.0107 76.6',
        inputBorderHover: '0.806 0.0173 76.5',
        inputBorderFocus: '0.806 0.0173 76.5',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.767 0.0209 76.5',
        inputBorderHighlight: '0.808 0.0222 76.5',
        inputBgActive: '0.941 0.0037 76.6',
        inputBgHighlight: '0.949 0.0058 76.6',
        inputBgDisabled: '0.941 0.0037 76.6',
        inputPlaceholder: '0.649 0.0181 76.5',
        tabBg: '0.948 0.0032 76.6',
        tabBgHover: '0.926 0.0046 76.6',
        tabOutline: '0.819 0.0114 76.6',
        borderSubtle: '0.881 0.009 76.6',
        borderDefault: '0.82 0.0137 76.6',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '0.218 0.0088 67.3',
        inputBorder: '0.284 0.0132 67.3',
        inputBorderHover: '0.348 0.0197 67.1',
        inputBorderFocus: '0.348 0.0197 67.1',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.388 0.0227 67.1',
        inputBorderHighlight: '0.368 0.0212 67.1',
        inputBgActive: '0.252 0.0111 67.3',
        inputBgHighlight: '0.241 0.0103 67.3',
        inputBgDisabled: '0.195 0.0062 67.4',
        inputPlaceholder: '0.587 0.019 67.4',
        tabBg: '0.24 0.0089 67.4',
        tabBgHover: '0.284 0.0114 67.3',
        tabOutline: '0.346 0.0149 67.3',
        borderSubtle: '0.263 0.0118 67.3',
        borderDefault: '0.316 0.0153 67.2',
      },
      '1': {
        inputBg: '0.252 0.0111 67.3',
        inputBorder: '0.316 0.0153 67.2',
        inputBorderHover: '0.378 0.0219 67.1',
        inputBorderFocus: '0.378 0.0219 67.1',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.417 0.0248 67.1',
        inputBorderHighlight: '0.398 0.0234 67.1',
        inputBgActive: '0.284 0.0132 67.3',
        inputBgHighlight: '0.274 0.0125 67.3',
        inputBgDisabled: '0.229 0.0082 67.4',
        inputPlaceholder: '0.587 0.019 67.4',
        tabBg: '0.273 0.0108 67.4',
        tabBgHover: '0.315 0.0131 67.3',
        tabOutline: '0.376 0.0165 67.3',
        borderSubtle: '0.295 0.0139 67.2',
        borderDefault: '0.347 0.0173 67.2',
      },
      '2': {
        inputBg: '0.347 0.0173 67.2',
        inputBorder: '0.406 0.0211 67.2',
        inputBorderHover: '0.465 0.0283 67',
        inputBorderFocus: '0.465 0.0283 67',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.503 0.031 67',
        inputBorderHighlight: '0.484 0.0297 67',
        inputBgActive: '0.377 0.0192 67.2',
        inputBgHighlight: '0.367 0.0186 67.2',
        inputBgDisabled: '0.284 0.0114 67.3',
        inputPlaceholder: '0.587 0.019 67.4',
        tabBg: '0.366 0.016 67.3',
        tabBgHover: '0.405 0.0182 67.3',
        tabOutline: '0.425 0.0192 67.3',
        borderSubtle: '0.387 0.0199 67.2',
        borderDefault: '0.426 0.0224 67.2',
      },
      '3': {
        inputBg: '0.326 0.016 67.2',
        inputBorder: '0.387 0.0199 67.2',
        inputBorderHover: '0.446 0.0269 67',
        inputBorderFocus: '0.446 0.0269 67',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.484 0.0297 67',
        inputBorderHighlight: '0.465 0.0283 67',
        inputBgActive: '0.357 0.018 67.2',
        inputBgHighlight: '0.347 0.0173 67.2',
        inputBgDisabled: '0.262 0.0101 67.4',
        inputPlaceholder: '0.587 0.019 67.4',
        tabBg: '0.346 0.0149 67.3',
        tabBgHover: '0.386 0.0171 67.3',
        tabOutline: '0.405 0.0182 67.3',
        borderSubtle: '0.367 0.0186 67.2',
        borderDefault: '0.406 0.0211 67.2',
      },
      '4': {
        inputBg: '0.367 0.0186 67.2',
        inputBorder: '0.426 0.0224 67.2',
        inputBorderHover: '0.484 0.0297 67',
        inputBorderFocus: '0.484 0.0297 67',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.521 0.0324 67',
        inputBorderHighlight: '0.503 0.031 67',
        inputBgActive: '0.397 0.0205 67.2',
        inputBgHighlight: '0.387 0.0199 67.2',
        inputBgDisabled: '0.305 0.0125 67.3',
        inputPlaceholder: '0.587 0.019 67.4',
        tabBg: '0.386 0.0171 67.3',
        tabBgHover: '0.425 0.0192 67.3',
        tabOutline: '0.444 0.0203 67.3',
        borderSubtle: '0.406 0.0211 67.2',
        borderDefault: '0.445 0.0236 67.2',
      },
    },
  },

  ayu: {
    light: {
      surface0: '0.992 0.0009 247.8',
      surface0Hover: '0.969 0.0035 247.9',
      surface0Active: '0.945 0.0062 247.9',
      surface0Highlight: '0.961 0.0044 247.9',
      surface1: '1 0 0',
      surface1Hover: '0.961 0.0037 247.9',
      surface1Active: '0.937 0.006 247.9',
      surface1Highlight: '0.953 0.0045 247.9',
      surface2: '0.937 0.0049 247.9',
      surface2Hover: '0.953 0.0037 247.9',
      surface2Active: '0.914 0.0068 247.9',
      surface2Highlight: '0.929 0.0072 247.9',
      surface3: '1 0 0',
      surface3Hover: '0.977 0.0013 247.8',
      surface3Active: '0.954 0.0026 247.9',
      surface3Highlight: '0.969 0.0024 247.8',
      surface4: '0.985 0.003 248',
      surface4Hover: '0.965 0.004 248',
      surface4Active: '0.945 0.005 248',
      surface4Highlight: '0.96 0.006 248',
      accent: '0.962 0.0262 67.5',
      accentForeground: '0.517 0.147 43.6',
      accentHover: '0.925 0.0526 67.1',
      sidebarAccent: '0.58 0.2 70',
      sidebarAccentForeground: '1 0 0',
      sidebarHover: '0.959 0.0158 67.6',
      borderSubtle: '0.906 0.0075 247.9',
      borderDefault: '0.842 0.0127 248',
      borderMainContent: '0.899 0.0101 247.95',
      inputBg: '1 0 0',
      inputBorder: '0.906 0.0075 247.9',
      inputBorderHover: '0.841 0.0145 248',
      inputBorderFocus: '0.65 0.1823 51.8',
      inputBorderActive: '0.801 0.0183 248.1',
      inputBorderHighlight: '0.841 0.0163 248',
      inputBgActive: '0.977 0.0016 247.8',
      inputBgHighlight: '0.977 0.0024 247.8',
      inputBgDisabled: '0.969 0.0021 247.8',
      inputPlaceholder: '0.645 0.0131 253.4',
      tabBg: '0.922 0.0062 247.9',
      tabBgHover: '0.89 0.0087 247.9',
      tabOutline: '0.826 0.012 248',
      background: '0.992 0.0009 247.8',
      panelBackground: '1 0 0',
      mainPanelBackground: '1 0 0',
      ring: '0.734 0.2 70',
      contentPreviewBg: '0.93 0.005 248',
      contentPreviewFg: '0.45 0.015 248',
      contentPreviewBorder: '0.86 0.008 248',
    },
    dark: {
      surface0: '0.162 0.0139 264.1',
      surface0Hover: '0.194 0.02 263.9',
      surface0Active: '0.224 0.0257 263.8',
      surface0Highlight: '0.204 0.0219 263.9',
      surface1: '0.184 0.0168 264',
      surface1Hover: '0.215 0.0222 263.9',
      surface1Active: '0.245 0.0274 263.9',
      surface1Highlight: '0.225 0.024 263.9',
      surface2: '0.27 0.018 255',
      surface2Hover: '0.308 0.018 255',
      surface2Active: '0.337 0.018 255',
      surface2Highlight: '0.318 0.018 255',
      surface3: '0.25 0.012 255',
      surface3Hover: '0.289 0.012 255',
      surface3Active: '0.318 0.012 255',
      surface3Highlight: '0.299 0.012 255',
      surface4: '0.289 0.006 255',
      surface4Hover: '0.327 0.006 255',
      surface4Active: '0.355 0.006 255',
      surface4Highlight: '0.337 0.006 255',
      accent: '0.298 0.0477 82.3',
      accentForeground: '0.881 0.1043 83.8',
      accentHover: '0.374 0.0631 81.8',
      sidebarAccent: '0.801 0.2 70',
      sidebarAccentForeground: '0.181 0.0241 263.7',
      sidebarHover: '0.225 0.024 263.9',
      borderSubtle: '0.289 0.0217 264.2',
      borderDefault: '0.346 0.0277 264.1',
      borderMainContent: '0.296 0.0247 264.15',
      inputBg: '0.228 0.0188 264.1',
      inputBorder: '0.308 0.0237 264.1',
      inputBorderHover: '0.381 0.035 264',
      inputBorderFocus: '0.65 0.1378 81.5',
      inputBorderActive: '0.417 0.0392 264',
      inputBorderHighlight: '0.399 0.0371 264',
      inputBgActive: '0.258 0.0228 264.1',
      inputBgHighlight: '0.248 0.0214 264.1',
      inputBgDisabled: '0.207 0.016 264.1',
      inputPlaceholder: '0.569 0.0216 264.4',
      tabBg: '0.27 0.0196 264.2',
      tabBgHover: '0.308 0.0237 264.1',
      tabOutline: '0.384 0.0279 264.2',
      background: '0.162 0.0139 264.1',
      panelBackground: '0.184 0.0168 264',
      mainPanelBackground: '0.184 0.0168 264',
      ring: '0.801 0.2 70',
      contentPreviewBg: '0.225 0.018 264',
      contentPreviewFg: '0.7 0.022 264',
      contentPreviewBorder: '0.31 0.022 264',
    },
    surfaceScopesLight: {
      '0': {
        inputBg: '1 0 0',
        inputBorder: '0.89 0.0087 247.9',
        inputBorderHover: '0.825 0.016 248',
        inputBorderFocus: '0.734 0.1823 51.8',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.784 0.0199 248.1',
        inputBorderHighlight: '0.825 0.018 248',
        inputBgActive: '0.977 0.0016 247.8',
        inputBgHighlight: '0.977 0.0024 247.8',
        inputBgDisabled: '0.961 0.0026 247.8',
        inputPlaceholder: '0.645 0.0131 253.4',
        tabBg: '0.922 0.0062 247.9',
        tabBgHover: '0.89 0.0087 247.9',
        tabOutline: '0.826 0.012 248',
        borderSubtle: '0.906 0.0075 247.9',
        borderDefault: '0.842 0.0127 248',
      },
      '1': {
        inputBg: '1 0 0',
        inputBorder: '0.89 0.0087 247.9',
        inputBorderHover: '0.825 0.016 248',
        inputBorderFocus: '0.734 0.1823 51.8',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.784 0.0199 248.1',
        inputBorderHighlight: '0.825 0.018 248',
        inputBgActive: '0.977 0.0016 247.8',
        inputBgHighlight: '0.977 0.0024 247.8',
        inputBgDisabled: '0.961 0.0026 247.8',
        inputPlaceholder: '0.645 0.0131 253.4',
        tabBg: '0.922 0.0062 247.9',
        tabBgHover: '0.89 0.0087 247.9',
        tabOutline: '0.826 0.012 248',
        borderSubtle: '0.906 0.0075 247.9',
        borderDefault: '0.842 0.0127 248',
      },
      '2': {
        inputBg: '0.992 0.0006 247.8',
        inputBorder: '0.874 0.01 247.9',
        inputBorderHover: '0.817 0.0168 248',
        inputBorderFocus: '0.734 0.1823 51.8',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.776 0.0207 248.1',
        inputBorderHighlight: '0.816 0.0189 248.1',
        inputBgActive: '0.969 0.0021 247.8',
        inputBgHighlight: '0.969 0.0031 247.9',
        inputBgDisabled: '0.953 0.0032 247.9',
        inputPlaceholder: '0.645 0.0131 253.4',
        tabBg: '0.906 0.0064 247.9',
        tabBgHover: '0.882 0.008 247.9',
        tabOutline: '0.826 0.012 248',
        borderSubtle: '0.89 0.0087 247.9',
        borderDefault: '0.834 0.0133 248',
      },
      '3': {
        inputBg: '0.969 0.0024 247.8',
        inputBorder: '0.866 0.0107 248',
        inputBorderHover: '0.809 0.0175 248',
        inputBorderFocus: '0.734 0.1823 51.8',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.768 0.0215 248.1',
        inputBorderHighlight: '0.808 0.0197 248.1',
        inputBgActive: '0.946 0.0037 247.9',
        inputBgHighlight: '0.953 0.0047 247.9',
        inputBgDisabled: '0.946 0.0037 247.9',
        inputPlaceholder: '0.645 0.0131 253.4',
        tabBg: '0.953 0.0032 247.9',
        tabBgHover: '0.93 0.0048 247.9',
        tabOutline: '0.826 0.012 248',
        borderSubtle: '0.89 0.0087 247.9',
        borderDefault: '0.826 0.014 248',
      },
      '4': {
        inputBg: '0.969 0.0024 247.8',
        inputBorder: '0.866 0.0107 248',
        inputBorderHover: '0.809 0.0175 248',
        inputBorderFocus: '0.734 0.1823 51.8',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.768 0.0215 248.1',
        inputBorderHighlight: '0.808 0.0197 248.1',
        inputBgActive: '0.946 0.0037 247.9',
        inputBgHighlight: '0.953 0.0047 247.9',
        inputBgDisabled: '0.946 0.0037 247.9',
        inputPlaceholder: '0.645 0.0131 253.4',
        tabBg: '0.953 0.0032 247.9',
        tabBgHover: '0.93 0.0048 247.9',
        tabOutline: '0.826 0.012 248',
        borderSubtle: '0.89 0.0087 247.9',
        borderDefault: '0.826 0.014 248',
      },
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '0.207 0.016 264.1',
        inputBorder: '0.27 0.0196 264.2',
        inputBorderHover: '0.326 0.0286 264.1',
        inputBorderFocus: '0.801 0.1378 81.5',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.363 0.0329 264',
        inputBorderHighlight: '0.344 0.0308 264',
        inputBgActive: '0.238 0.0201 264.1',
        inputBgHighlight: '0.228 0.0188 264.1',
        inputBgDisabled: '0.187 0.0107 264.3',
        inputPlaceholder: '0.569 0.0216 264.4',
        tabBg: '0.23 0.0136 264.3',
        tabBgHover: '0.271 0.0174 264.2',
        tabOutline: '0.329 0.0228 264.2',
        borderSubtle: '0.25 0.0175 264.2',
        borderDefault: '0.299 0.0227 264.1',
      },
      '1': {
        inputBg: '0.228 0.0188 264.1',
        inputBorder: '0.289 0.0217 264.2',
        inputBorderHover: '0.344 0.0308 264',
        inputBorderFocus: '0.801 0.1378 81.5',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.381 0.035 264',
        inputBorderHighlight: '0.363 0.0329 264',
        inputBgActive: '0.258 0.0228 264.1',
        inputBgHighlight: '0.248 0.0214 264.1',
        inputBgDisabled: '0.208 0.0131 264.2',
        inputPlaceholder: '0.569 0.0216 264.4',
        tabBg: '0.251 0.0155 264.2',
        tabBgHover: '0.29 0.0192 264.2',
        tabOutline: '0.348 0.0245 264.2',
        borderSubtle: '0.27 0.0196 264.2',
        borderDefault: '0.318 0.0247 264.1',
      },
      '2': {
        inputBg: '0.307 0.0264 264.1',
        inputBorder: '0.364 0.0296 264.1',
        inputBorderHover: '0.417 0.0392 264',
        inputBorderFocus: '0.801 0.1378 81.5',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.451 0.0432 264',
        inputBorderHighlight: '0.434 0.0412 264',
        inputBgActive: '0.335 0.0297 264.1',
        inputBgHighlight: '0.326 0.0286 264.1',
        inputBgDisabled: '0.25 0.0175 264.2',
        inputPlaceholder: '0.569 0.0216 264.4',
        tabBg: '0.329 0.0228 264.2',
        tabBgHover: '0.366 0.0262 264.2',
        tabOutline: '0.402 0.0296 264.2',
        borderSubtle: '0.346 0.0277 264.1',
        borderDefault: '0.383 0.0315 264.1',
      },
      '3': {
        inputBg: '0.288 0.0241 264.1',
        inputBorder: '0.346 0.0277 264.1',
        inputBorderHover: '0.399 0.0371 264',
        inputBorderFocus: '0.801 0.1378 81.5',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.434 0.0412 264',
        inputBorderHighlight: '0.417 0.0392 264',
        inputBgActive: '0.317 0.0275 264.1',
        inputBgHighlight: '0.307 0.0264 264.1',
        inputBgDisabled: '0.229 0.0153 264.2',
        inputPlaceholder: '0.569 0.0216 264.4',
        tabBg: '0.31 0.021 264.2',
        tabBgHover: '0.348 0.0245 264.2',
        tabOutline: '0.384 0.0279 264.2',
        borderSubtle: '0.327 0.0257 264.1',
        borderDefault: '0.364 0.0296 264.1',
      },
      '4': {
        inputBg: '0.326 0.0286 264.1',
        inputBorder: '0.383 0.0315 264.1',
        inputBorderHover: '0.434 0.0412 264',
        inputBorderFocus: '0.801 0.1378 81.5',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.469 0.0451 264',
        inputBorderHighlight: '0.451 0.0432 264',
        inputBgActive: '0.354 0.0319 264',
        inputBgHighlight: '0.344 0.0308 264',
        inputBgDisabled: '0.27 0.0196 264.2',
        inputPlaceholder: '0.569 0.0216 264.4',
        tabBg: '0.348 0.0245 264.2',
        tabBgHover: '0.384 0.0279 264.2',
        tabOutline: '0.42 0.0312 264.2',
        borderSubtle: '0.364 0.0296 264.1',
        borderDefault: '0.401 0.0333 264.1',
      },
    },
  },

  doodles: {
    dark: {
      surface0: '0.216 0 0',
      surface0Hover: '0.248 0 0',
      surface1: '0.216 0 0',
      surface1Hover: '0.248 0 0',
      contentPreviewBg: '0.32 0 0',
      contentPreviewFg: '0.715 0 0',
      contentPreviewBorder: '0.371 0 0',
    },
  },

  black: {
    dark: {
      surface0: '0.128 0 0',
      surface0Hover: '0.158 0 0',
      surface0Active: '0.193 0 0',
      surface0Highlight: '0.17 0 0',
      surface1: '0.17 0.004 286',
      surface1Hover: '0.199 0.0055 285.9',
      surface1Active: '0.231 0.007 285.8',
      surface1Highlight: '0.21 0.006 285.9',
      surface2: '0.204 0 0',
      surface2Hover: '0.248 0 0',
      surface2Active: '0.28 0 0',
      surface2Highlight: '0.259 0 0',
      surface3: '0.19 0.0033 286.1',
      surface3Hover: '0.223 0.0043 286',
      surface3Active: '0.254 0.0053 286',
      surface3Highlight: '0.233 0.0047 286',
      surface4: '0.238 0 0',
      surface4Hover: '0.27 0 0',
      surface4Active: '0.301 0 0',
      surface4Highlight: '0.28 0 0',
      fg: '0.885 0 0',
      fgSecondary: '0.641 0 0',
      fgTertiary: '0.528 0 0',
      fgDisabled: '0.399 0 0',
      borderSubtle: '0.238 0 0',
      borderDefault: '0.301 0 0',
      borderMainContent: '0.213 0 0',
      accent: '0.182 0 0',
      accentForeground: '0.923 0 0',
      accentHover: '0.227 0 0',
      sidebarAccent: '0.182 0 0',
      sidebarAccentForeground: '0.923 0 0',
      sidebarHover: '0.146 0 0',
      tabBg: '0.204 0 0',
      tabBgHover: '0.248 0 0',
      tabOutline: '0.321 0 0',
      inputBg: '0.182 0 0',
      inputBorder: '0.259 0 0',
      inputBorderHover: '0.321 0 0',
      inputBorderFocus: '0.376 0 0',
      inputBorderActive: '0.361 0 0',
      inputBorderHighlight: '0.341 0 0',
      inputBgActive: '0.216 0 0',
      inputBgHighlight: '0.204 0 0',
      inputBgDisabled: '0.158 0 0',
      inputPlaceholder: '0.528 0 0',
      background: '0.128 0 0',
      panelBackground: '0.149 0.0029 286',
      mainPanelBackground: '0.17 0.004 286',
      contentPreviewBg: '0.18 0 0',
      contentPreviewFg: '0.7 0 0',
      contentPreviewBorder: '0.27 0 0',
    },
    surfaceScopesDark: {
      '0': {
        inputBg: '0.182 0 0',
        inputBorder: '0.238 0 0',
        inputBorderHover: '0.301 0 0',
        inputBorderFocus: '0.356 0 0',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.341 0 0',
        inputBorderHighlight: '0.321 0 0',
        inputBgActive: '0.216 0 0',
        inputBgHighlight: '0.204 0 0',
        inputBgDisabled: '0.146 0 0',
        inputPlaceholder: '0.528 0 0',
        tabBg: '0.193 0 0',
        tabBgHover: '0.238 0 0',
        tabOutline: '0.301 0 0',
        borderSubtle: '0.216 0 0',
        borderDefault: '0.27 0 0',
      },
      '1': {
        inputBg: '0.216 0 0',
        inputBorder: '0.27 0 0',
        inputBorderHover: '0.331 0 0',
        inputBorderFocus: '0.386 0 0',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.371 0 0',
        inputBorderHighlight: '0.351 0 0',
        inputBgActive: '0.248 0 0',
        inputBgHighlight: '0.238 0 0',
        inputBgDisabled: '0.158 0 0',
        inputPlaceholder: '0.528 0 0',
        tabBg: '0.227 0 0',
        tabBgHover: '0.27 0 0',
        tabOutline: '0.321 0 0',
        borderSubtle: '0.248 0 0',
        borderDefault: '0.29 0 0',
      },
      '2': {
        inputBg: '0.248 0 0',
        inputBorder: '0.301 0 0',
        inputBorderHover: '0.361 0 0',
        inputBorderFocus: '0.416 0 0',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.399 0 0',
        inputBorderHighlight: '0.38 0 0',
        inputBgActive: '0.28 0 0',
        inputBgHighlight: '0.27 0 0',
        inputBgDisabled: '0.182 0 0',
        inputPlaceholder: '0.528 0 0',
        tabBg: '0.259 0 0',
        tabBgHover: '0.301 0 0',
        tabOutline: '0.341 0 0',
        borderSubtle: '0.28 0 0',
        borderDefault: '0.321 0 0',
      },
      '3': {
        inputBg: '0.238 0 0',
        inputBorder: '0.28 0 0',
        inputBorderHover: '0.341 0 0',
        inputBorderFocus: '0.396 0 0',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.38 0 0',
        inputBorderHighlight: '0.361 0 0',
        inputBgActive: '0.27 0 0',
        inputBgHighlight: '0.259 0 0',
        inputBgDisabled: '0.17 0 0',
        inputPlaceholder: '0.528 0 0',
        tabBg: '0.248 0 0',
        tabBgHover: '0.29 0 0',
        tabOutline: '0.321 0 0',
        borderSubtle: '0.27 0 0',
        borderDefault: '0.301 0 0',
      },
      '4': {
        inputBg: '0.28 0 0',
        inputBorder: '0.341 0 0',
        inputBorderHover: '0.399 0 0',
        inputBorderFocus: '0.454 0 0',
        inputBorderError: '0.562 0.1966 26.3',
        inputBorderActive: '0.437 0 0',
        inputBorderHighlight: '0.418 0 0',
        inputBgActive: '0.311 0 0',
        inputBgHighlight: '0.301 0 0',
        inputBgDisabled: '0.216 0 0',
        inputPlaceholder: '0.528 0 0',
        tabBg: '0.301 0 0',
        tabBgHover: '0.341 0 0',
        tabOutline: '0.38 0 0',
        borderSubtle: '0.321 0 0',
        borderDefault: '0.361 0 0',
      },
    },
  },

  white: {
    light: {
      surface0: '0.962 0 0',
      surface0Hover: '0.939 0 0',
      surface0Active: '0.916 0 0',
      surface0Highlight: '0.931 0 0',
      surface1: '1 0 0',
      surface1Hover: '0.977 0 0',
      surface1Active: '0.954 0 0',
      surface1Highlight: '0.97 0 0',
      surface2: '0.97 0 0',
      surface2Hover: '0.97 0 0',
      surface2Active: '0.947 0 0',
      surface2Highlight: '0.962 0 0',
      surface3: '1 0 0',
      surface3Hover: '0.977 0 0',
      surface3Active: '0.954 0 0',
      surface3Highlight: '0.97 0 0',
      surface4: '0.985 0.003 0',
      surface4Hover: '0.965 0.004 0',
      surface4Active: '0.945 0.005 0',
      surface4Highlight: '0.96 0.006 0',
      borderSubtle: '0.908 0 0',
      borderDefault: '0.845 0 0',
      borderMainContent: '0.925 0 0',
      accent: '0.97 0 0',
      accentForeground: '0.204 0 0',
      accentHover: '0.923 0 0',
      sidebarAccent: '0.97 0 0',
      sidebarAccentForeground: '0.204 0 0',
      sidebarHover: '0.962 0 0',
      tabBg: '0.947 0 0',
      tabBgHover: '0.923 0 0',
      tabOutline: '0.861 0 0',
      inputBg: '1 0 0',
      inputBorder: '0.908 0 0',
      inputBorderHover: '0.845 0 0',
      inputBorderFocus: '0.65 0 0',
      inputBorderActive: '0.805 0 0',
      inputBorderHighlight: '0.829 0 0',
      inputBgActive: '0.977 0 0',
      inputBgHighlight: '0.985 0 0',
      inputBgDisabled: '0.97 0 0',
      inputPlaceholder: '0.649 0 0',
      background: '0.962 0 0',
      panelBackground: '1 0 0',
      mainPanelBackground: '1 0 0',
      contentPreviewBg: '0.91 0 0',
      contentPreviewFg: '0.45 0 0',
      contentPreviewBorder: '0.86 0 0',
    },
    surfaceScopesLight: {
      '0': {
        inputBg: '1 0 0',
        inputBorder: '0.892 0 0',
        inputBorderHover: '0.829 0 0',
        inputBorderFocus: '0.829 0 0',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.789 0 0',
        inputBorderHighlight: '0.813 0 0',
        inputBgActive: '0.977 0 0',
        inputBgHighlight: '0.985 0 0',
        inputBgDisabled: '0.962 0 0',
        inputPlaceholder: '0.649 0 0',
        tabBg: '0.931 0 0',
        tabBgHover: '0.908 0 0',
        tabOutline: '0.845 0 0',
        borderSubtle: '0.9 0 0',
        borderDefault: '0.837 0 0',
      },
      '1': {
        inputBg: '0.97 0 0',
        inputBorder: '0.885 0 0',
        inputBorderHover: '0.829 0 0',
        inputBorderFocus: '0.829 0 0',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.789 0 0',
        inputBorderHighlight: '0.813 0 0',
        inputBgActive: '0.947 0 0',
        inputBgHighlight: '0.954 0 0',
        inputBgDisabled: '0.947 0 0',
        inputPlaceholder: '0.649 0 0',
        tabBg: '0.954 0 0',
        tabBgHover: '0.931 0 0',
        tabOutline: '0.845 0 0',
        borderSubtle: '0.892 0 0',
        borderDefault: '0.829 0 0',
      },
      '2': {
        inputBg: '0.992 0 0',
        inputBorder: '0.885 0 0',
        inputBorderHover: '0.829 0 0',
        inputBorderFocus: '0.829 0 0',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.789 0 0',
        inputBorderHighlight: '0.813 0 0',
        inputBgActive: '0.97 0 0',
        inputBgHighlight: '0.977 0 0',
        inputBgDisabled: '0.954 0 0',
        inputPlaceholder: '0.649 0 0',
        tabBg: '0.947 0 0',
        tabBgHover: '0.923 0 0',
        tabOutline: '0.845 0 0',
        borderSubtle: '0.892 0 0',
        borderDefault: '0.829 0 0',
      },
      '3': {
        inputBg: '0.97 0 0',
        inputBorder: '0.885 0 0',
        inputBorderHover: '0.829 0 0',
        inputBorderFocus: '0.829 0 0',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.789 0 0',
        inputBorderHighlight: '0.813 0 0',
        inputBgActive: '0.947 0 0',
        inputBgHighlight: '0.954 0 0',
        inputBgDisabled: '0.947 0 0',
        inputPlaceholder: '0.649 0 0',
        tabBg: '0.954 0 0',
        tabBgHover: '0.931 0 0',
        tabOutline: '0.845 0 0',
        borderSubtle: '0.892 0 0',
        borderDefault: '0.829 0 0',
      },
      '4': {
        inputBg: '0.97 0 0',
        inputBorder: '0.885 0 0',
        inputBorderHover: '0.829 0 0',
        inputBorderFocus: '0.829 0 0',
        inputBorderError: '0.636 0.2082 25.4',
        inputBorderActive: '0.789 0 0',
        inputBorderHighlight: '0.813 0 0',
        inputBgActive: '0.947 0 0',
        inputBgHighlight: '0.954 0 0',
        inputBgDisabled: '0.947 0 0',
        inputPlaceholder: '0.649 0 0',
        tabBg: '0.954 0 0',
        tabBgHover: '0.931 0 0',
        tabOutline: '0.845 0 0',
        borderSubtle: '0.892 0 0',
        borderDefault: '0.829 0 0',
      },
    },
  },

};

// ---------------------------------------------------------------------------
// Preset metadata
// ---------------------------------------------------------------------------

export const THEME_PRESETS: Record<ThemePresetId, ThemePreset> = {
  default: {
    id: 'default',
    name: 'Default',
    description: 'Classic neutral grays',
    preview: {
      light: { bg: '#F2F1EE', accent: '#f5f5f5', text: '#171717' },
      dark: { bg: '#242424', accent: '#1a1a1a', text: '#fafafa' },
    },
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean',
    description: 'Deep blue serenity',
    preview: {
      light: { bg: '#F0F7FF', accent: '#3B82F6', text: '#1E40AF' },
      dark: { bg: '#050D17', accent: '#2563EB', text: '#BFDBFE' },
    },
  },
  forest: {
    id: 'forest',
    name: 'Forest',
    description: 'Natural green tones',
    preview: {
      light: { bg: '#F0FDF4', accent: '#22C55E', text: '#166534' },
      dark: { bg: '#040F09', accent: '#16A34A', text: '#BBF7D0' },
    },
  },
  berry: {
    id: 'berry',
    name: 'Berry',
    description: 'Rich purple vibes',
    preview: {
      light: { bg: '#FAF5FF', accent: '#A855F7', text: '#6B21A8' },
      dark: { bg: '#0D0514', accent: '#9333EA', text: '#E9D5FF' },
    },
  },
  sand: {
    id: 'sand',
    name: 'Sand',
    description: 'Warm neutral warmth',
    preview: {
      light: { bg: '#F5EDDF', accent: '#B37A3A', text: '#4D3519' },
      dark: { bg: '#120E08', accent: '#A36B2D', text: '#E8D5B8' },
    },
  },
  ayu: {
    id: 'ayu',
    name: 'Ayu',
    description: 'Bright accent on deep navy',
    preview: {
      light: { bg: '#FCFCFC', accent: '#FF9940', text: '#5C6166' },
      dark: { bg: '#0B0E14', accent: '#E6B450', text: '#BFBDB6' },
    },
  },
  doodles: {
    id: 'doodles',
    name: 'Doodles',
    description: 'Playful sketched background',
    preview: {
      light: { bg: '#F2F1EE', accent: '#e5e5e5', text: '#171717' },
      dark: { bg: '#1a1a1a', accent: '#262626', text: '#fafafa' },
    },
  },
  black: {
    id: 'black',
    name: 'Black',
    description: 'True black for OLED',
    allowedModes: ['dark'],
    preview: {
      light: { bg: '#F2F1EE', accent: '#f5f5f5', text: '#171717' },
      dark: { bg: '#070707', accent: '#0A0A0D', text: '#e0e0e0' },
    },
  },
  white: {
    id: 'white',
    name: 'White',
    description: 'Clean white surfaces',
    allowedModes: ['light'],
    preview: {
      light: { bg: '#FFFFFF', accent: '#f0f0f0', text: '#171717' },
      dark: { bg: '#141414', accent: '#1a1a1a', text: '#fafafa' },
    },
  },
};

export const THEME_PRESET_IDS: ThemePresetId[] = [
  'default', 'ocean', 'forest', 'berry', 'sand', 'ayu', 'doodles', 'black', 'white',
];

// ---------------------------------------------------------------------------
// Shadow tokens
// ---------------------------------------------------------------------------

export const SHADOWS_LIGHT: ThemeShadows = {
  shadow0: '0 1px 2px oklch(0 0 0 / 0.05)',
  shadow1: '0 1px 3px oklch(0 0 0 / 0.1), 0 1px 2px oklch(0 0 0 / 0.06)',
  shadow2: '0 4px 6px oklch(0 0 0 / 0.1), 0 2px 4px oklch(0 0 0 / 0.06)',
  shadow3: '0 10px 15px oklch(0 0 0 / 0.1), 0 4px 6px oklch(0 0 0 / 0.05)',
  shadow4: '0 20px 25px oklch(0 0 0 / 0.1), 0 8px 10px oklch(0 0 0 / 0.04)',
};

export const SHADOWS_DARK: ThemeShadows = {
  shadow0: '0 1px 2px oklch(0 0 0 / 0.2)',
  shadow1: '0 1px 3px oklch(0 0 0 / 0.3), 0 1px 2px oklch(0 0 0 / 0.2)',
  shadow2: '0 4px 6px oklch(0 0 0 / 0.3), 0 2px 4px oklch(0 0 0 / 0.2)',
  shadow3: '0 10px 15px oklch(0 0 0 / 0.3), 0 4px 6px oklch(0 0 0 / 0.2)',
  shadow4: '0 20px 25px oklch(0 0 0 / 0.3), 0 8px 10px oklch(0 0 0 / 0.15)',
};

export const SHADOW_TO_CSS: Record<keyof ThemeShadows, string> = {
  shadow0: '--harmony-shadow-0',
  shadow1: '--harmony-shadow-1',
  shadow2: '--harmony-shadow-2',
  shadow3: '--harmony-shadow-3',
  shadow4: '--harmony-shadow-4',
};

// ---------------------------------------------------------------------------
// CSS variable name mappings
// ---------------------------------------------------------------------------

export const TOKEN_TO_CSS: Record<keyof ThemeColors, string> = {
  surface0: '--harmony-surface-0',
  surface0Hover: '--harmony-surface-0-hover',
  surface0Active: '--harmony-surface-0-active',
  surface0Highlight: '--harmony-surface-0-highlight',
  surface1: '--harmony-surface-1',
  surface1Hover: '--harmony-surface-1-hover',
  surface1Active: '--harmony-surface-1-active',
  surface1Highlight: '--harmony-surface-1-highlight',
  surface2: '--harmony-surface-2',
  surface2Hover: '--harmony-surface-2-hover',
  surface2Active: '--harmony-surface-2-active',
  surface2Highlight: '--harmony-surface-2-highlight',
  surface3: '--harmony-surface-3',
  surface3Hover: '--harmony-surface-3-hover',
  surface3Active: '--harmony-surface-3-active',
  surface3Highlight: '--harmony-surface-3-highlight',
  surface4: '--harmony-surface-4',
  surface4Hover: '--harmony-surface-4-hover',
  surface4Active: '--harmony-surface-4-active',
  surface4Highlight: '--harmony-surface-4-highlight',
  fg: '--harmony-fg',
  fgSecondary: '--harmony-fg-secondary',
  fgTertiary: '--harmony-fg-tertiary',
  fgDisabled: '--harmony-fg-disabled',
  fgInverse: '--harmony-fg-inverse',
  fgLink: '--harmony-fg-link',
  fgSuccess: '--harmony-fg-success',
  fgWarning: '--harmony-fg-warning',
  fgError: '--harmony-fg-error',
  borderSubtle: '--harmony-border-subtle',
  borderDefault: '--harmony-border-default',
  borderMainContent: '--harmony-border-main-content',
  borderSuccess: '--harmony-border-success',
  borderWarning: '--harmony-border-warning',
  borderError: '--harmony-border-error',
  accent: '--accent',
  accentForeground: '--accent-foreground',
  accentHover: '--accent-hover',
  accentActive: '--accent-active',
  accentSubtle: '--accent-subtle',
  accentMuted: '--accent-muted',
  accentBorder: '--accent-border',
  ctaBg: '--cta-bg',
  ctaFg: '--cta-fg',
  ctaBgHover: '--cta-bg-hover',
  ctaBgActive: '--cta-bg-active',
  ctaBorder: '--cta-border',
  sidebarAccent: '--sidebar-accent',
  sidebarAccentForeground: '--sidebar-accent-foreground',
  sidebarHover: '--sidebar-hover',
  tabBg: '--harmony-tab-bg',
  tabBgHover: '--harmony-tab-bg-hover',
  tabOutline: '--harmony-tab-outline',
  inputBg: '--harmony-input-bg',
  inputBorder: '--harmony-input-border',
  inputBorderHover: '--harmony-input-border-hover',
  inputBorderFocus: '--harmony-input-border-focus',
  inputBorderError: '--harmony-input-border-error',
  inputBorderActive: '--harmony-input-border-active',
  inputBorderHighlight: '--harmony-input-border-highlight',
  inputBgActive: '--harmony-input-bg-active',
  inputBgHighlight: '--harmony-input-bg-highlight',
  inputBgDisabled: '--harmony-input-bg-disabled',
  inputPlaceholder: '--harmony-input-placeholder',
  bgSuccess: '--harmony-bg-success',
  bgWarning: '--harmony-bg-warning',
  bgError: '--harmony-bg-error',
  contentPreviewBg: '--harmony-content-preview-bg',
  contentPreviewFg: '--harmony-content-preview-fg',
  contentPreviewBorder: '--harmony-content-preview-border',
};

export const EXTENDED_CSS: Record<string, string> = {
  background: '--background',
  panelBackground: '--panel-bg',
  mainPanelBackground: '--main-panel-bg',
  ring: '--ring',
  overlay: '--overlay',
  surfaceGlass: '--surface-glass',
  skeleton: '--skeleton',
};

// ---------------------------------------------------------------------------
// Layout tokens — spacing & border-radius (universal)
// ---------------------------------------------------------------------------

export const SPACING: ThemeSpacing = {
  spacing0: '0',
  spacing05: '0.25rem',
  spacing1: '0.5rem',
  spacing15: '0.75rem',
  spacing2: '1rem',
  spacing3: '1.5rem',
  spacing4: '2rem',
  spacing5: '2.5rem',
  spacing6: '3rem',
  spacing8: '4rem',
  spacing10: '5rem',
  spacing12: '6rem',
};

export const BORDER_RADIUS: ThemeBorderRadius = {
  radiusNone: '0',
  radiusSm: '0.25rem',
  radiusMd: '0.5rem',
  radiusLg: '0.75rem',
  radiusXl: '1rem',
  radius2xl: '1.5rem',
  radiusFull: '9999px',
};

export const SPACING_TO_CSS: Record<keyof ThemeSpacing, string> = {
  spacing0: '--spacing-0',
  spacing05: '--spacing-0-5',
  spacing1: '--spacing-1',
  spacing15: '--spacing-1-5',
  spacing2: '--spacing-2',
  spacing3: '--spacing-3',
  spacing4: '--spacing-4',
  spacing5: '--spacing-5',
  spacing6: '--spacing-6',
  spacing8: '--spacing-8',
  spacing10: '--spacing-10',
  spacing12: '--spacing-12',
};

export const RADIUS_TO_CSS: Record<keyof ThemeBorderRadius, string> = {
  radiusNone: '--radius-none',
  radiusSm: '--radius-sm',
  radiusMd: '--radius-md',
  radiusLg: '--radius-lg',
  radiusXl: '--radius-xl',
  radius2xl: '--radius-2xl',
  radiusFull: '--radius-full',
};
